import * as _ from "lodash-es";
import moment from "moment";
import { Moment } from "moment-timezone";
import React, { ChangeEvent, Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { FormattedMessage } from "react-intl";
import ReactModal from "react-modal";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import ContextEnum from "../../../models/ContextEnum";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetCatalogsDTO from "../../../models/DTO/IGetCatalogsDTO";
import IGetClientsDTO from "../../../models/DTO/IGetClientsDTO";
import IGetProjectsForVendorDTO from "../../../models/DTO/IGetProjectsForVendorDTO";
import IGetServiceLevelsDTO from "../../../models/DTO/IGetServiceLevelsDTO";
import IGetShipstationCarriersDTO from "../../../models/DTO/IGetShipstationCarriersDTO";
import IGetShipstationPackageTypesForCarrierDTO from "../../../models/DTO/IGetShipstationPackageTypesForCarrierDTO";
import IGetShipstationServicesForCarrierDTO from "../../../models/DTO/IGetShipstationServicesForCarrierDTO";
import IGetSupplierUserVendorsDTO from "../../../models/DTO/IGetSupplierUserVendorsDTO";
import IGetVendorAddressesDTO from "../../../models/DTO/IGetVendorAddressesDTO";
import IGetVendorSourceLocationsDTO from "../../../models/DTO/IGetVendorSourceLocationsDTO";
import IGetWarehousesDTO from "../../../models/DTO/IGetWarehousesDTO";
import IOnGetCatalogsDTO from "../../../models/DTO/IOnGetCatalogsDTO";
import IOnGetClientsDTO from "../../../models/DTO/IOnGetClientsDTO";
import IOnGetProjectsForVendorDTO from "../../../models/DTO/IOnGetProjectsForVendorDTO";
import IOnGetServiceLevelsDTO from "../../../models/DTO/IOnGetServiceLevelsDTO";
import IOnGetShipstationCarriersDTO from "../../../models/DTO/IOnGetShipstationCarriersDTO";
import IOnGetShipstationPackageTypesForCarrierDTO from "../../../models/DTO/IOnGetShipstationPackageTypesForCarrierDTO";
import IOnGetShipstationServicesForCarrierDTO from "../../../models/DTO/IOnGetShipstationServicesForCarrierDTO";
import IOnGetSupplierUserVendorsDTO from "../../../models/DTO/IOnGetSupplierUserVendorsDTO";
import IOnGetVendorAddressesDTO from "../../../models/DTO/IOnGetVendorAddressesDTO";
import IOnGetVendorSourceLocationsDTO from "../../../models/DTO/IOnGetVendorSourceLocationsDTO";
import IOnGetWarehousesDTO from "../../../models/DTO/IOnGetWarehousesDTO";
import IOnQBOGetClassesDTO from "../../../models/DTO/IOnQBOGetClassesDTO";
import IOnTypeaheadLookupByTokenTypeDTO from "../../../models/DTO/IOnTypeaheadLookupByTokenTypeDTO";
import IQBOGetClassesDTO from "../../../models/DTO/IQBOGetClassesDTO";
import ITypeaheadLookupByTokenTypeDTO from "../../../models/DTO/ITypeaheadLookupByTokenTypeDTO";
import IUpdateOrderEntryDetailDTO from "../../../models/DTO/IUpdateOrderEntryDetailDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import GoogleMapsMarkerSizeEnum from "../../../models/Google Maps/GoogleMapsMarkerSizeEnum";
import IAddress from "../../../models/IAddress";
import ICatalog from "../../../models/ICatalog";
import IClient from "../../../models/IClient";
import IDraftOrderItem from "../../../models/IDraftOrderItem";
import INewOrder_Details from "../../../models/INewOrder_Details";
import INotification from "../../../models/INotification";
import IOrder from "../../../models/IOrder";
import IOrderDetailConfig from "../../../models/IOrderDetailConfig";
import IPrice_Group from "../../../models/IPrice_Group";
import IProject from "../../../models/IProject";
import IServiceLevel from "../../../models/IServiceLevel";
import IStandardRoomDetailItem from "../../../models/IStandardRoomDetailItem";
import ISupplierModel from "../../../models/ISupplierModel";
import IUser from "../../../models/IUser";
import IUserUI from "../../../models/IUserUI";
import IVendor_Source_Location from "../../../models/IVendor_Source_Location";
import IVendorModel from "../../../models/IVendorModel";
import IWarehouse from "../../../models/IWarehouse";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import OrderSourceEnum from "../../../models/OrderSourceEnum";
import IQBOClassDTO from "../../../models/QuickBooks Online/IQBOClassDTO";
import RoomDetailItemTypeEnum from "../../../models/RoomDetailItemTypeEnum";
import IShipstationCarrierDTO from "../../../models/Shipstation/IShipstationCarrierDTO";
import IShipstationPackageTypeDTO from "../../../models/Shipstation/IShipstationPackageTypeDTO";
import IShipstationServiceTypeDTO from "../../../models/Shipstation/IShipstationServiceTypeDTO";
import TokenTypesEnum from "../../../models/TokenTypesEnum";
import UserTypesEnum from "../../../models/UserTypesEnum";
import systemConst from "../../../services/SystemConst";
import UIService from "../../../services/UIService";

import UserService from "../../../services/UserService";
import VendorService from "../../../services/VendorService";
import ActivityIndicator from "../../shared/ActivityIndicator/ActivityIndicator";
import AddressBlock from "../../shared/AddressBlock/AddressBlock";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import OwButton from "../../shared/OwButton/OwButton";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import ChipSizeEnum from "../../shared/OwChips/ChipSizeEnum";
import { OwContinueConfirmModal } from "@components/shared/OwContinueConfirmModal/OwContinueConfirmModal";
import OwDateInput from "../../shared/OwDateInput/OwDateInput";
import OwGoogleStaticMap from "../../shared/OwGoogleStaticMap/OwGoogleStaticMap";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwObjectChips from "../../shared/OwObjectChips/OwObjectChips";
import OwSelectOption from "../../shared/OwSelectOption/OwSelectOption";
import OwTextArea from "../../shared/OwTextArea/OwTextArea";
import OwTranslate from "../../shared/OwTranslate/OwTranslate";
import Typeahead from "../../shared/Typeahead/Typeahead";
import OrderAddressSidebar from "../OrderAddressSidebar/OrderAddressSidebar";
import OrderEntryCsvImport from "../OrderEntryCsvImport/OrderEntryCsvImport";
import OrderEntryFileManager from "../OrderEntryFileManager/OrderEntryFileManager";
import UseClientAddressModal from "../UseClientAddressModal/UseClientAddressModal";
import "./OrderEntryDetailsPanel.scss";
import IOnGetCategoriesDTO from "../../../models/DTO/IOnGetCategoriesDTO";
import IGetCategoriesDTO from "../../../models/DTO/IGetCategoriesDTO";
import ICategory from "../../../models/ICategory";
import IContact from "../../../models/IContact";
import IGetContactsDTO from "../../../models/DTO/IGetContactsDTO";
import IOnGetContactsDTO from "../../../models/DTO/IOnGetContactsDTO";
import IGetVendorsDTO from "../../../models/DTO/IGetVendorsDTO";
import IOnGetVendorsDTO from "../../../models/DTO/IOnGetVendorsDTO";
import TaxJarExemptionTypeEnum from "../../../models/TaxJar/TaxJarExemptionTypeEnum";
import SupplierService from "../../../services/SupplierService";
import quickBooksIcon from "../../../assets/images/quickbooks/QB_16x16.png";
import IRepGroup from "../../../models/IRepGroup";
import { IGetRepGroupsDTO } from "../../../models/DTO/IGetRepGroupsDTO";
import IOnGetRepGroupsDTO from "../../../models/DTO/IOnGetRepGroupsDTO";
import IWorkflow from "../../../models/IWorkflow";
import IGetWorkflowsDTO from "../../../models/DTO/IGetWorkflowsDTO";
import IOnGetWorkflowsDTO from "../../../models/DTO/IOnGetWorkflowsDTO";
import { CreateContactModal } from "../../shared/CreateContactModal/CreateContactModal";
import ICreateContactDTO from "../../../models/DTO/ICreateContactDTO";

import { Socket } from "socket.io-client";
import IQBDShipMethodOption from "../../../models/QuickBooks Desktop/IQBDShipMethodOption";
import SupplierGuidEnum from "../../../models/SupplierGuidEnum";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import INewAddress from "../../../models/INewAddress";
import IUiSocketSetup from "../../../models/IUiSocketSetup";
import IOnGetRoutesDTO from "../../../models/DTO/IOnGetRoutesDTO";
import IGetRoutesDTO from "../../../models/DTO/IGetRoutesDTO";
import IRoute from "../../../models/IRoute";
import OwBadge from "../../shared/OwBadge/OwBadge";
import ITag from "../../../models/ITag";
import IGetTagsDTO from "../../../models/DTO/IGetTagsDTO";
import IOnGetTagsDTO from "../../../models/DTO/IOnGetTagsDTO";
import IProcessTagDTO from "../../../models/DTO/IProcessTagDTO";
import IOnProcessTagDTO from "../../../models/DTO/IOnProcessTagDTO";
import { OrderEntryShipmentsPanel } from "../OrderEntryShipmentsPanel/OrderEntryShipmentsPanel";
import { ButtonGroup } from "react-bootstrap";
import { OrderEntryPurchaseOrderPanel } from "../OrderEntryPurchaseOrderPanel/OrderEntryPurchaseOrderPanel";
import ClientSidebar from "../../clients/ClientSidebar/ClientSidebar";
import AccessTypesEnum from "../../../models/AccessTypesEnum";
import { IAddBulkItems } from "@models/IAddBulkItems";
import IRelatedOrder from "@models/IRelatedOrder";
import { RelatedOrdersPanel } from "../RelatedOrdersPanel/RelatedOrdersPanel";
import { OrderEntryRmasPanel } from "../OrderEntryRmasPanel/OrderEntryRmasPanel";
import { UnanetOrderSyncStatus } from "../UnanetOrderSyncStatus/UnanetOrderSyncStatus";
import { OrderEntryFastboundPanel } from "../OrderEntryFastboundPanel/OrderEntryFastboundPanel";

type Props = {
    order: IOrder;
    priceGroups?: IPrice_Group[];
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    updateOrderEntryDetail: (data: Partial<IUpdateOrderEntryDetailDTO>, isDetailSaveOnly?: boolean) => void;
    updateOrderEntryFineDetails: (data: Partial<INewOrder_Details>) => void;
    setTempUpdateOrderFineDetails: (data: Partial<INewOrder_Details>, isValid: boolean) => void;
    processCustomSchedule: (custom_schedule: any) => void;
    addBulkItems: (items: IAddBulkItems[]) => void;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    vendorModel?: IVendorModel;
    pendingChangesFn: (hasPendingChanges: boolean) => void;
    history: any;
    location: any;
    match: any;
    isReadOnly: boolean;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    isEcommerceView?: boolean;
    getOrder: () => void;
    // readOnly?: boolean;
    relatedOrders?: IRelatedOrder[];
};

type State = {
    detailsEditMode: boolean;
    details: any;
    vendors: IVendorModel[];
    order: IOrder;
    vendorModel?: IVendorModel;
    isSupplierUser?: boolean;
    clients: IClient[];
    catalogs: ICatalog[];
    priceGroups: IPrice_Group[];
    editMode?: boolean;
    CategoryHierarchy?: string;
    // isOnline: boolean;
    isOfflineOrder: boolean;
    vendorAddresses: IAddress[];
    projects: IProject[];
    labelWidth: string;
    componentWidth: string;
    serviceLevels: IServiceLevel[];
    shipstationCarriers: IShipstationCarrierDTO[];
    shipstationServiceTypes: IShipstationServiceTypeDTO[];
    shipstationPackageTypes: IShipstationPackageTypeDTO[];
    getShipstationCarriersActive: boolean;
    getShipstationCarrierServicesActive: boolean;
    getShipstationPackageTypeActive: boolean;
    modalComponent?: any;
    modalIsOpen: boolean;
    originalServiceLevelId?: any;
    foundVendorAddresses: IAddress[];
    performingVendorAddressLookup: boolean;
    clearTypeahead: boolean;
    selectedAddress?: IAddress;
    save_address_to_vendor: boolean;
    foundVendorUsers?: IUser[];
    selectedAssignedUser?: IUser | null;
    assignedUsers: { guid: string; name: string; email: string }[];
    clearAssignedUserTypeahead: boolean;
    onlyNonAssignedAddresses: boolean;
    vendorSourceLocations: IVendor_Source_Location[];
    // offlineMode$?: Subscription;
    modalHeight: string;
    clearClientTypeahead: boolean;
    clearUserTypeahead: boolean;
    foundUsers: IUser[];
    clearCommissionUsersTypeahead: boolean;
    foundCommissionUsers: IUser[];
    commissionUserLookup: boolean;
    selectedUser?: IUser | null;
    selectedCommissionUser?: IUser | null;
    warehouses?: IWarehouse[];
    qboClasses: IQBOClassDTO[];
    qbo_InvoiceClassRef?: string | null;
    workflow_id?: number | null;
    orderCategories: ICategory[];
    contactName?: string;
    contacts: IContact[];
    clearContactTypeahead: boolean;
    clearVendorTypeahead: boolean;
    selectedRepGroup?: IRepGroup | null;
    clearRepGroupTypeahead: boolean;
    clearRepGroup: boolean;
    foundRepGroups: IRepGroup[];
    workflows: IWorkflow[];
    qbd_ship_via?: IQBDShipMethodOption;
    dot_cert?: boolean;
    dot_cert_contact?: string;
    dot_cert_state?: string;
    is_noninventory_order?: boolean;
    exchange_rate?: number;
    route_id?: number;
    availableRoutes: IRoute[];
    tags: ITag[];
    foundTags: ITag[];
    selectedTag?: ITag;
    clearTagTypeahead: boolean;
    mdColumns: string;
    viewAllDetails: boolean;
};

class OrderEntryDetailsPanel extends Component<Props, State> {
    static defaultProps = {
        priceGroups: [],
    };

    sockets: IUiSocketSetup[] = [];

    constructor(props: any) {
        super(props);

        const labelWidth = this.props.isEcommerceView ? "" : "min-w-30";
        const componentWidth = this.props.isEcommerceView ? "" : "w-70";

        this.state = {
            clients: [],
            serviceLevels: [],
            detailsEditMode: false,
            details: {},
            isSupplierUser: false,
            vendors: [],
            vendorAddresses: [],
            order: {} as IOrder,
            // isOnline: UIService.offlineModeSubject$().value,
            isOfflineOrder: false, //this.props.match.params.order_guid.indexOf("offline") >= 0,
            catalogs: [],
            priceGroups: [],
            projects: [],
            qbo_InvoiceClassRef: this.props.order.qbo_InvoiceClassRef,
            CategoryHierarchy: this.props.order.CategoryHierarchy
                ? _.map(this.props.order.CategoryHierarchy, (item) => {
                      return item.name;
                  }).join(" - ")
                : undefined,
            labelWidth,
            componentWidth,
            shipstationCarriers: [],
            shipstationServiceTypes: [],
            shipstationPackageTypes: [],
            getShipstationCarriersActive: false,
            getShipstationCarrierServicesActive: false,
            getShipstationPackageTypeActive: false,
            modalComponent: null,
            modalIsOpen: false,
            performingVendorAddressLookup: false,
            foundVendorAddresses: [],
            clearTypeahead: false,
            save_address_to_vendor: false,
            foundVendorUsers: [],
            selectedAssignedUser: null,
            clearAssignedUserTypeahead: false,
            onlyNonAssignedAddresses: this.props.userModel.guid !== "265b1f0f-6a8a-4464-a638-aaa316c93720",
            assignedUsers: this.getAssignedUsers(),
            vendorSourceLocations: [],
            modalHeight: "15rem",
            clearClientTypeahead: false,
            clearUserTypeahead: false,
            foundUsers: [],
            clearCommissionUsersTypeahead: false,
            foundCommissionUsers: [],
            commissionUserLookup: false,
            warehouses: [],
            qboClasses: [],
            orderCategories: [],
            contacts: [],
            clearContactTypeahead: false,
            clearVendorTypeahead: false,
            clearRepGroupTypeahead: false,
            foundRepGroups: [],
            clearRepGroup: false,
            workflows: [],
            workflow_id: this.props.order.workflow_id,
            is_noninventory_order: this.props.order.is_noninventory_order,
            exchange_rate: this.props.order.exchange_rate,
            route_id: this.props.order.route_id,
            availableRoutes: [],
            tags: this.props.order.Tags || [],
            foundTags: [],
            clearTagTypeahead: false,
            mdColumns: this.props.supplierModel.guid === SupplierGuidEnum.PANASONIC_CA ? "col-md-3" : "col-md-4",
            viewAllDetails: false,
        };

        this.sockets = [
            { endpoint: EndpointsEnum.ClientOnGetClients, fn: this.onGetClients },
            { endpoint: EndpointsEnum.ShipstationOnGetServicesForCarriers, fn: this.onShipstationGetServices },
            { endpoint: EndpointsEnum.ShipstationOnGetPackageTypesForCarriers, fn: this.onShipstationGetPackageTypes },
            { endpoint: EndpointsEnum.AddressOnGetVendorAddresses, fn: this.onGetVendorAddresses },
            { endpoint: EndpointsEnum.TokenOnTypeaheadLookupByTokenType, fn: this.onLookupVendorUser },
            { endpoint: EndpointsEnum.PurchaseOrderOnGetVendorSourceLocations, fn: this.onGetVendorSourceLocations },
            { endpoint: EndpointsEnum.TokenOnTypeaheadLookupByTokenType, fn: this.onTypeaheadLookupByTokenType },
            { endpoint: EndpointsEnum.ClientOnGetClients, fn: this.onGetClients },
            { endpoint: EndpointsEnum.WarehouseOnGetWarehouses, fn: this.onGetWarehouses },
            { endpoint: EndpointsEnum.QBOOnGetClasses, fn: this.qboOnGetClasses },
            { endpoint: EndpointsEnum.CategoriesOnGetCategories, fn: this.onGetOrderCategories },
            { endpoint: EndpointsEnum.ContactsOnGetContacts, fn: this.onGetContacts },
            { endpoint: EndpointsEnum.VendorsOnGetVendors, fn: this.onGetVendors },
            { endpoint: EndpointsEnum.RepGroupOnGetRepGroups, fn: this.onLookupRepGroup },
            { endpoint: EndpointsEnum.WorkflowsOnGetWorkflows, fn: this.onGetWorkflows },
            { endpoint: EndpointsEnum.ContactsOnCreateContact, fn: this.onCreateContact },
            { endpoint: EndpointsEnum.RoutesOnGetRoutes, fn: this.onGetRoutes },
            { endpoint: EndpointsEnum.TagsOnProcessTag, fn: this.onProcessTag },
            { endpoint: EndpointsEnum.TagsOnGetTags, fn: this.onGetTags },
        ];
    }

    async componentDidMount() {
        const vendorModel = this.props.vendorModel;

        this.setupSockets();

        window.addEventListener("online", this.setOnlineStatus);
        window.addEventListener("offline", this.setOnlineStatus);

        // const offlineMode$ = UIService.offlineModeSubject$().subscribe((isOnline) => {
        //     this.setState({
        //         isOnline,
        //     });
        // });

        const state = {
            // offlineMode$,
            order: this.props.order,
            vendorModel,
            isSupplierUser: this.props.userModel.isSupplierUser,
            originalServiceLevelId: this.props.order.service_level_id,
        } as State;

        this.setState(state, () => {
            // if (this.state.isOnline) {
            // this.getClients();
            this.getProjectsForVendor();
            this.getCatalogs();
            this.getServiceLevels();

            if (this.props.supplierModel.has_warehouses) {
                this.getWarehouses();
            }

            if (this.props.supplierModel.Supplier_Integration.has_shipstation) {
                this.shipstationGetCarriers();

                if (this.state.order.shipstation_serviceType) {
                    this.shipstationGetServiceTypes();
                }

                if (this.state.order.shipstation_packageType) {
                    this.shipstationGetPackageTypes();
                }
            }

            if (this.props.supplierModel.Supplier_Integration.has_qbo) {
                if (this.props.supplierModel.Supplier_Integration.qbo_using_classes) {
                    this.qboGetClasses();
                }
            }

            if (this.props.order.vendor_source_id) {
                this.getVendorSourceLocations();
            }

            if (this.props.userModel.isSupplierUser && this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN) {
                this.getWorkflows();
            }
            // } else {
            //     // TODO get clients from jsstore
            // }

            if (this.state.isSupplierUser) {
                // if (this.state.isOnline) {
                //     // this.getSupplierUserVendors();
                // } else {
                //     // TODO load the vendors from jsstore.
                // }
            }
        });
    }

    getAssignedUsers = () => {
        const assignedUsers: { guid: string; email: string; name: string }[] = [];

        if (this.props.order.Assigned_Users) {
            for (const assignedUser of this.props.order.Assigned_Users) {
                assignedUsers.push({ guid: assignedUser.guid, name: assignedUser.name, email: assignedUser.email });
            }
        }

        return assignedUsers;
    };

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevProps.order !== this.props.order) {
            this.setState({
                order: this.props.order,
                assignedUsers: this.getAssignedUsers(),
            });
        }
    }

    componentWillUnmount(): void {
        window.removeEventListener("online", this.setOnlineStatus);
        window.removeEventListener("offline", this.setOnlineStatus);

        // if (this.state.isOnline) {
        for (const socket of this.sockets) {
            this.props.socket.removeListener(socket.endpoint, socket.fn);
        }
        // }

        // if (this.state.offlineMode$) {
        //     this.state.offlineMode$.unsubscribe();
        // }
    }

    setupSockets = () => {
        // if (this.state.isOnline) {
        this.props.socket.once(EndpointsEnum.CatalogsOnGetCatalogs, this.onGetCatalogs);
        this.props.socket.once(EndpointsEnum.SupplierOnGetSupplierUserVendors, this.onGetSupplierUserVendors);
        this.props.socket.once(EndpointsEnum.ProjectsOnGetProjectsForVendor, this.onGetProjectsForVendor);
        this.props.socket.once(EndpointsEnum.ShipstationOnGetCarriers, this.onShipstationGetCarriers);

        for (const socket of this.sockets) {
            this.props.socket.on(socket.endpoint, socket.fn);
        }

        if (this.props.supplierModel.has_service_levels) {
            this.props.socket.once(EndpointsEnum.SuppliersOnGetServiceLevels, this.onGetServiceLevels);
        }

        if (this.props.supplierModel.has_order_categories) {
            this.getOrderCategories();
        }
        // }
    };

    setOnlineStatus = () => {
        // this.setState({
        //     isOnline: navigator.onLine,
        // });
    };

    getWorkflows = () => {
        const payload: IGetWorkflowsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.WorkflowsGetWorkflows, payload);
    };

    onGetWorkflows = (data: IOnGetWorkflowsDTO) => {
        this.setState({
            workflows: data.workflows,
        });
    };

    getVendorSourceLocations = () => {
        if (this.props.order.Vendor_Source) {
            const payload: IGetVendorSourceLocationsDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                vendorSourceGuid: this.props.order.Vendor_Source.guid,
            };

            this.props.socket.emit(EndpointsEnum.PurchaseOrderGetVendorSourceLocations, payload);
        }
    };

    onGetVendorSourceLocations = (data: IOnGetVendorSourceLocationsDTO) => {
        this.setState({
            vendorSourceLocations: data.locations,
        });
    };

    shipstationGetCarriers = () => {
        const payload: IGetShipstationCarriersDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.order.Vendor!.guid;
        }

        this.props.socket.emit(EndpointsEnum.ShipstationGetCarriers, payload);

        this.setState({
            getShipstationCarriersActive: true,
        });
    };

    onShipstationGetCarriers = (data: IOnGetShipstationCarriersDTO) => {
        this.setState({
            shipstationCarriers: data.carriers,
            getShipstationCarriersActive: false,
        });
    };

    shipstationGetServiceTypes = () => {
        if (!this.state.order.shipstation_carrierCode) {
            return;
        }

        const payload: IGetShipstationServicesForCarrierDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            shipstation_carrierCode: this.state.order.shipstation_carrierCode,
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.order.Vendor!.guid;
        }

        this.props.socket.emit(EndpointsEnum.ShipstationGetServicesForCarriers, payload);

        this.setState({
            getShipstationCarrierServicesActive: true,
        });
    };

    onShipstationGetServices = (data: IOnGetShipstationServicesForCarrierDTO) => {
        this.setState({
            shipstationServiceTypes: data.serviceTypes,
            getShipstationCarrierServicesActive: false,
        });
    };

    shipstationGetPackageTypes = () => {
        if (this.state.order.shipstation_serviceType && this.state.order.shipstation_carrierCode) {
            const payload: IGetShipstationPackageTypesForCarrierDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
                shipstation_carrierCode: this.state.order.shipstation_carrierCode,
                shipstation_serviceType: this.state.order.shipstation_serviceType,
            };

            if (!this.props.userModel.isSupplierUser) {
                payload.vendorGuid = this.props.order.Vendor!.guid;
            }

            this.props.socket.emit(EndpointsEnum.ShipstationGetPackageTypesForCarriers, payload);

            this.setState({
                getShipstationPackageTypeActive: true,
            });
        }
    };

    onShipstationGetPackageTypes = (data: IOnGetShipstationPackageTypesForCarrierDTO) => {
        this.setState({
            shipstationPackageTypes: data.packageTypes,
            getShipstationPackageTypeActive: false,
        });
    };

    getWarehouses = () => {
        const payload: IGetWarehousesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.vendorModel?.guid;
        }

        this.props.socket.emit(EndpointsEnum.WarehouseGetWarehouses, payload);
    };

    onGetWarehouses = (data: IOnGetWarehousesDTO) => {
        this.setState({
            warehouses: data.warehouses,
        });
    };

    getOrderCategories = () => {
        const payload: IGetCategoriesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            isOrderCategory: true,
            onlyRootCategories: false,
        };

        if (!this.props.userModel.isSupplierUser) {
            payload.vendorGuid = this.props.order.Vendor?.guid;
        }

        this.props.socket.emit(EndpointsEnum.CategoriesGetCategories, payload);
    };

    onGetOrderCategories = (data: IOnGetCategoriesDTO) => {
        if (data.isOrderCategory) {
            const categories = data.categories.filter((category) => !category.hide_category);
            this.setState({
                orderCategories: categories,
            });
        }
    };

    qboGetClasses = () => {
        if (this.props.userModel.isSupplierUser) {
            const payload: IQBOGetClassesDTO = {
                userGuid: this.props.userModel.guid,
                userToken: this.props.userModel.token,
                supplierGuid: this.props.supplierModel.guid,
            };

            this.props.socket.emit(EndpointsEnum.QBOGetClasses, payload);
        }
    };

    qboOnGetClasses = (data: IOnQBOGetClassesDTO) => {
        this.setState({
            qboClasses: data.classes,
        });
    };

    getServiceLevels = () => {
        const payload: IGetServiceLevelsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.state.vendorModel ? this.state.vendorModel.guid : undefined,
        };

        this.props.socket.emit(EndpointsEnum.SuppliersGetServiceLevels, payload);
    };

    onGetServiceLevels = (data: IOnGetServiceLevelsDTO) => {
        this.setState({
            serviceLevels: data.serviceLevels,
        });
    };

    getSupplierUserVendors = () => {
        const supplierUserVendorsPayload: IGetSupplierUserVendorsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: this.props.order.Vendor?.guid,
            supplierGuid: this.props.supplierModel.guid,
            userToGetGuid: this.props.userModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.SupplierGetSupplierUserVendors, supplierUserVendorsPayload);
    };

    getClients = (name?: string) => {
        const payload: IGetClientsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: this.props.order.Vendor?.guid,
            supplierGuid: this.props.supplierModel.guid,
        };

        if (name) {
            payload.queryString = `name=${name}`;
        }

        this.props.socket.emit(EndpointsEnum.ClientGetClients, payload);

        this.setState({
            clients: [],
        });
    };

    onGetClients = (data: IOnGetClientsDTO) => {
        const state: any = {
            clients: data.clients,
        };

        this.setState(state);
    };

    getProjectsForVendor = () => {
        const payload: IGetProjectsForVendorDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.order.Vendor?.guid,
        };

        this.props.socket.emit(EndpointsEnum.ProjectsGetProjectsForVendor, payload);
    };

    onGetProjectsForVendor = (data: IOnGetProjectsForVendorDTO) => {
        this.setState({
            projects: data.projects,
        });
    };

    getCatalogs = () => {
        const payload: IGetCatalogsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            vendorGuid: this.props.order.Vendor?.guid,
            supplierGuid: this.props.supplierModel.guid,
            onlyActive: true,
            checkIfHasCategories: true,
            callMeta: {
                view: "OrderEntryDetailsPanel",
                fn: "getCatalogs",
            },
        };

        this.props.socket.emit(EndpointsEnum.CatalogsGetCatalogs, payload);
    };

    onGetCatalogs = (data: IOnGetCatalogsDTO) => {
        let priceGroups: IPrice_Group[] = [];

        if (this.props.order.catalog_id) {
            _.each(data.catalogs, (catalog) => {
                if (catalog.id === this.props.order.catalog_id) {
                    priceGroups = catalog.Price_Groups || [];
                }
            });
        }

        this.setState({
            catalogs: data.catalogs,
            priceGroups,
        });
    };

    onGetSupplierUserVendors = (data: IOnGetSupplierUserVendorsDTO) => {
        this.setState({
            vendors: data.vendors,
        });
    };

    toggleViewAllDetails = () => {
        this.setState({
            viewAllDetails: !this.state.viewAllDetails,
        });
    };

    /**
     * Function to toggle the details panel Edit Mode
     *
     * @param e
     * @param cancel
     */
    toggleDetailsEditMode = (e?: any, cancel?: boolean) => {
        const state: any = {
            detailsEditMode: !this.state.detailsEditMode,
        };

        if (cancel) {
            state.order = this.props.order;
        }

        if (state.detailsEditMode) {
            state.viewAllDetails = true;
        } else {
            state.viewAllDetails = false;
        }

        this.setState(state, () => {
            if (cancel) {
                this.props.pendingChangesFn(false);
            }
        });
    };

    renderShipToStreets = (detail: IStandardRoomDetailItem, index: number) => {
        const label = <OwLabel title={"address"} noBottomMargin={true} className={this.state.labelWidth} postText={":"} isBold={true} />;
        const display = (
            <div className={`col-12 ${this.state.mdColumns} mb-1`}>
                <div className={"d-flex w-100"}>
                    {label}
                    <AddressDisplay
                        prefix={"Ship_To."}
                        showName={false}
                        address={this.props.order}
                        showCompanyName={false}
                        showPhone={false}
                        hideEmail={true}
                        hideFax={true}
                        hideMobile={true}
                        hideCity={true}
                        hideCountry={true}
                        hidePostalCode={true}
                        hideState={true}
                        wrapperTag={"span"}
                    />
                </div>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span>{label}</span>
                    {this.getAddressDetailView(detail, index)}
                </div>
            );

            return edit;
        }
    };

    renderShipTo = (detail: IStandardRoomDetailItem, index: number) => {
        if (this.props.order.is_local_pickup) {
            return null;
        }

        const label = <OwLabel title={"ship_to"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex flex-column w-100"}>
                <div>{label}</div>
                {this.getAddressDisplay(detail)}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span>{label}</span>
                    {this.getAddressDetailView(detail, index)}
                </div>
            );

            return edit;
        }
    };

    renderDescription = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.description) {
                return null;
            }
        }

        const label = <OwLabel title={"description"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.description}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwTextArea
                            name={"description"}
                            fn={(e: any) => {
                                this.rowUpdate(e, detail, index, "description");
                            }}
                            value={this.state.order.description}
                        />
                    </span>
                </div>
            );

            return edit;
        }
    };

    handleSpecDueDate = (dateMoment: Moment) => {
        const order = this.state.order;

        order.details!.spec_due_date = dateMoment.format("YYYY-MM-DD");

        this.setState({
            order,
        });
    };

    renderSpecDueDate = (detail: IStandardRoomDetailItem) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.details?.spec_due_date) {
                return null;
            }
        }

        const label = <OwLabel title={"spec_due_date"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {UserService.parseDate(this.state.order.Order_Detail?.spec_due_date)}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwDateInput selectedDate={this.state.order.details?.spec_due_date} fn={this.handleSpecDueDate} isUTC={true} />
                    </span>
                </div>
            );

            return edit;
        }
    };

    handleShipstationCarrierSelect = (e: ChangeEvent<any>) => {
        // const name = e.target.name;
        const value = e.target.value;

        const order = this.state.order;

        order.shipstation_carrierCode = value;

        this.setState(
            {
                order,
            },
            () => {
                this.shipstationGetServiceTypes();
            }
        );
    };

    getShipstationCarrierName = (): string => {
        let carrierName = "";

        if (this.state.shipstationCarriers) {
            for (const carrier of this.state.shipstationCarriers) {
                if (carrier.code === this.state.order.shipstation_carrierCode) {
                    carrierName = carrier.name;
                }
            }
        }

        return carrierName;
    };

    renderShipstationCarrierCode = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.shipstation_carrierCode) {
                return null;
            }
        }

        const label = <OwLabel title={"shipstation_carrier"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span>{label}</span>
                <span>
                    {this.state.getShipstationCarrierServicesActive ? (
                        <ActivityIndicator active={this.state.getShipstationCarrierServicesActive} />
                    ) : (
                        this.getShipstationCarrierName()
                    )}
                </span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex flex-column w-100"}>
                    <div>{label}</div>
                    <div>
                        <OwSelectOption
                            name={"shipstation_carrierCode"}
                            titleProp={"name"}
                            valueProp={"code"}
                            options={this.state.shipstationCarriers}
                            selectedOption={this.state.order}
                            selectedOptionProp={"shipstation_carrierCode"}
                            fn={this.handleShipstationCarrierSelect}
                            showBlankFirst={true}
                        />
                    </div>
                </div>
            );

            return edit;
        }
    };

    handleShipstationServiceTypeSelect = (e: ChangeEvent<any>) => {
        // const name = e.target.name;
        const value = e.target.value;

        const order = this.state.order;

        order.shipstation_serviceType = value;

        this.setState(
            {
                order,
            },
            () => {
                this.shipstationGetPackageTypes();
            }
        );
    };

    getShipstationServiceTypeName = (): string => {
        let serviceTypeName = "";

        if (this.state.shipstationServiceTypes) {
            for (const serviceType of this.state.shipstationServiceTypes) {
                if (serviceType.code === this.state.order.shipstation_serviceType) {
                    serviceTypeName = serviceType.name;
                }
            }
        }

        return serviceTypeName;
    };

    renderShipstationServiceTypes = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.shipstation_serviceType) {
                return null;
            }
        }

        const label = <OwLabel title={"shipstation_service_type"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span>{label}</span>
                <span>{this.getShipstationServiceTypeName()}</span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex flex-column w-100"}>
                    <div>{label}</div>
                    <div>
                        <OwSelectOption
                            name={"shipstation_serviceType"}
                            titleProp={"name"}
                            valueProp={"code"}
                            options={this.state.shipstationServiceTypes}
                            selectedOption={this.state.order}
                            selectedOptionProp={"shipstation_serviceType"}
                            fn={this.handleShipstationServiceTypeSelect}
                            showBlankFirst={true}
                        />
                    </div>
                </div>
            );

            return edit;
        }
    };

    handleShipstationPackageTypeSelect = (e: ChangeEvent<any>) => {
        // const name = e.target.name;
        const value = e.target.value;

        const order = this.state.order;

        order.shipstation_packageType = value;

        this.setState({
            order,
        });
    };

    getShipstationPackageTypeName = (): string => {
        let packageTypeName = "";

        if (this.state.shipstationPackageTypes) {
            for (const packageType of this.state.shipstationPackageTypes) {
                if (packageType.code === this.state.order.shipstation_packageType) {
                    packageTypeName = packageType.name;
                }
            }
        }

        return packageTypeName;
    };

    renderShipstationPackageTypes = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.shipstation_packageType) {
                return null;
            }
        }

        const label = <OwLabel title={"shipstation_package_type"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span>{label}</span>
                <span>{this.getShipstationPackageTypeName()}</span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex flex-column w-100"}>
                    <div>{label}</div>
                    <div>
                        <OwSelectOption
                            name={"shipstation_packageType"}
                            titleProp={"name"}
                            valueProp={"code"}
                            options={this.state.shipstationPackageTypes}
                            selectedOption={this.state.order}
                            selectedOptionProp={"shipstation_packageType"}
                            fn={this.handleShipstationPackageTypeSelect}
                            showBlankFirst={true}
                        />
                    </div>
                </div>
            );

            return edit;
        }
    };

    renderShippingInstructions = (detail: IStandardRoomDetailItem, index: number) => {
        if (this.props.order.is_local_pickup) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.shipping_instructions) {
                return null;
            }
        }

        const label = <OwLabel title={"shipping_instructions"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span>{label}</span>
                <span className={"pre-wrap"}>{this.state.order.shipping_instructions}</span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex flex-column w-100"}>
                    <div>{label}</div>
                    <div>
                        <OwTextArea
                            name={"shipping_instructions"}
                            fn={(e: any) => {
                                this.rowUpdate(e, detail, index, "shipping_instructions");
                            }}
                            value={this.state.order.shipping_instructions}
                        />
                    </div>
                </div>
            );

            return edit;
        }
    };

    renderServiceLevels = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.Service_Level) {
                return null;
            }
        }

        const label = <OwLabel title={"service_level"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order?.Service_Level?.name}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwSelectOption
                        valueProp={"id"}
                        titleProp={"name"}
                        name={"service_level_id"}
                        options={this.state.serviceLevels}
                        selectedOption={this.state.order}
                        selectedOptionProp={"service_level_id"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, "service_level_id");
                        }}
                        showBlankFirst={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderShippingWarehouse = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_warehouses) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.Shipping_Warehouse) {
                return null;
            }
        }

        const label = <OwLabel title={"shipping_warehouse"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={""}>{label}</span>
                {this.state.order?.Shipping_Warehouse?.name}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const warehouseOptions = this.props.order.Vendor?.Warehouses?.length
                ? this.props.order.Vendor?.Warehouses
                : this.state.warehouses;

            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwSelectOption
                        valueProp={"id"}
                        titleProp={"name"}
                        name={"shipping_warehouse_id"}
                        options={warehouseOptions}
                        selectedOption={this.state.order}
                        selectedOptionProp={"shipping_warehouse_id"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, "shipping_warehouse_id");
                        }}
                        showBlankFirst={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderCatalog = (detail: IStandardRoomDetailItem, index: number) => {
        let isCatalogReadOnly = false;

        if (this.props.order.Order_Items.length) {
            isCatalogReadOnly = true;
        }

        const label = <OwLabel title={"catalog"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.props.userModel.isSupplierUser && this.props.userModel.userType?.id === UserTypesEnum.ADMIN ? (
                    <Link to={`/catalogs/${this.state.order?.Catalog?.guid}`}>{this.state.order?.Catalog?.name}</Link>
                ) : (
                    this.state.order?.Catalog?.name
                )}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode || isCatalogReadOnly) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwSelectOption
                        valueProp={"id"}
                        titleProp={"name"}
                        name={"catalog_id"}
                        options={this.state.catalogs}
                        selectedOption={this.state.order}
                        selectedOptionProp={"catalog_id"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, "catalog_id");
                        }}
                        showBlankFirst={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderPriceGroups = (detail: IStandardRoomDetailItem, index: number) => {
        const label = <OwLabel title={"price_group"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order?.Price_Group?.value}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const priceGroups = _.sortBy(this.state.priceGroups, ["value"]);

            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwSelectOption
                        valueProp={"id"}
                        titleProp={"value"}
                        name={"price_group_id"}
                        options={priceGroups}
                        selectedOption={this.state.order}
                        selectedOptionProp={"price_group_id"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, "price_group_id");
                        }}
                        showBlankFirst={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderZoeyPaymentDetails = (detail: IStandardRoomDetailItem, index: number) => {
        const payments = this.props.order.Payments;
        let paymentDetails = "";

        if (payments) {
            if (_.isArray(payments)) {
                const paymentModel = payments[0];

                const captureDetail = JSON.parse(paymentModel.capture_detail || "");

                if (captureDetail?.additional_information?.authorize_cards) {
                    const key = Object.keys(captureDetail?.additional_information?.authorize_cards);

                    const cardDetail = captureDetail?.additional_information?.authorize_cards[key[0]];

                    paymentDetails = `${cardDetail.cc_type} ${cardDetail.cc_last4}`;
                }
            }
        }

        if (!this.state.viewAllDetails) {
            if (!paymentDetails.length) {
                return null;
            }
        }

        const label = <OwLabel title={"payment_details"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth} style={{ wordBreak: "break-all" }}>
                    {paymentDetails}
                </span>
            </div>
        );

        return display;
    };

    renderZoeyShippingDetails = (detail: IStandardRoomDetailItem, index: number) => {
        let shipping_detail = this.props.order.shipping_detail;

        if (shipping_detail) {
            if (_.isString(shipping_detail)) {
                shipping_detail = JSON.parse(shipping_detail);
            }
        }

        let details = ``;

        if (_.isArray(shipping_detail)) {
            const detailArrElem = shipping_detail[0];

            details = `${detailArrElem.carrierType} - ${detailArrElem.code} - ${detailArrElem.methodTitle}`;
        }

        if (!this.state.viewAllDetails) {
            if (!details.length) {
                return null;
            }
        }

        const label = <OwLabel title={"shipping_details"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth} style={{ wordBreak: "break-all" }}>
                    {details}
                </span>
            </div>
        );

        return display;
    };

    renderZoeyDeliveryDate = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.delivery_date?.length) {
                return null;
            }
        }

        const label = <OwLabel title={"delivery_date"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth} style={{ wordBreak: "break-all" }}>
                    {UserService.parseDate(this.state.order.delivery_date)}
                </span>
            </div>
        );

        return display;
    };

    renderZoeyOrderStatus = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.zoey_order_status) {
                return null;
            }
        }

        const label = <OwLabel title={"zoey_order_status"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth} style={{ wordBreak: "break-all" }}>
                    {this.state.order.zoey_order_status}
                </span>
            </div>
        );

        return display;
    };

    renderZoeyStatusHistory = (detail: IStandardRoomDetailItem) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.Order_Detail?.zoey_status_history) {
                return null;
            }
        }

        const label = <OwLabel title={"zoey_status_history"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth} style={{ wordBreak: "break-all" }}>
                    {this.state.order.Order_Detail?.zoey_status_history?.map((statusHistory, index) => {
                        return (
                            <div key={index} className={"text-small mt-2"}>
                                {statusHistory.comment}
                            </div>
                        );
                    })}
                </span>
            </div>
        );

        return display;
    };

    renderShipDate = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.ship_date) {
                return null;
            }
        }

        const label = <OwLabel title={"ship_date"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth} style={{ wordBreak: "break-all" }}>
                    {UserService.parseDate(this.state.order.ship_date)}
                </span>
            </div>
        );

        return display;
    };

    renderGiftMessage = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.gift_message) {
                return null;
            }
        }

        const label = <OwLabel title={"gift_message"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth} style={{ wordBreak: "break-all" }}>
                    {this.state.order.gift_message}
                </span>
            </div>
        );

        return display;
    };

    renderNote = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.note) {
                return null;
            }
        }

        const label = <OwLabel title={"note"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth} style={{ wordBreak: "break-all" }}>
                    {this.state.order.note}
                </span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwTextArea
                            name={"note"}
                            fn={(e: any) => {
                                this.rowUpdate(e, detail, index, "note");
                            }}
                            value={this.state.order.note}
                        />
                    </span>
                </div>
            );

            return edit;
        }
    };

    renderQboCustomField = (detail: IStandardRoomDetailItem, index: number, field: any | null, fieldNo: number) => {
        let displayValue: any;
        let fieldName = "qbo_CustomFieldValueOne";

        if (!field) {
            return null;
        }

        switch (fieldNo) {
            case 1:
                displayValue = this.state.order.qbo_CustomFieldValueOne;
                break;
            case 2:
                displayValue = this.state.order.qbo_CustomFieldValueTwo;
                fieldName = "qbo_CustomFieldValueTwo";
                break;
            case 3:
                displayValue = this.state.order.qbo_CustomFieldValueThree;
                fieldName = "qbo_CustomFieldValueThree";
                break;
        }

        // @ts-expect-error
        const value = this.state.order[fieldName];

        if (!this.state.viewAllDetails) {
            if (!value) {
                return null;
            }
        }

        const label = (
            <OwLabel title={field.StringValue} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} skipTranslate={true} />
        );
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth} style={{ wordBreak: "break-all" }}>
                    {displayValue}
                </span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwInputWrapper
                            name={fieldName}
                            fn={(e: any) => {
                                this.rowUpdate(e, detail, index, fieldName);
                            }}
                            value={value}
                        />
                    </span>
                </div>
            );

            return edit;
        }
    };

    renderQboCustomFieldsFn = (detail: IStandardRoomDetailItem, index: number) => {
        const qboCustomFieldOne = this.renderQboCustomField(
            detail,
            index,
            this.props.supplierModel.Supplier_Integration.qbo_CustomFieldOne,
            1
        );
        const qboCustomFieldTwo = this.renderQboCustomField(
            detail,
            index,
            this.props.supplierModel.Supplier_Integration.qbo_CustomFieldTwo,
            2
        );
        const qboCustomFieldThree = this.renderQboCustomField(
            detail,
            index,
            this.props.supplierModel.Supplier_Integration.qbo_CustomFieldThree,
            3
        );

        return (
            <>
                {qboCustomFieldOne}
                {qboCustomFieldTwo}
                {qboCustomFieldThree}
            </>
        );
    };

    clearCommissionUserTypeahead = () => {};

    lookupCommissionUser = (name: string) => {
        const payload: ITypeaheadLookupByTokenTypeDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
            tokenType: TokenTypesEnum.SUPPLIER_USER,
        };

        this.props.socket.emit(EndpointsEnum.TokenTypeaheadLookupByTokenType, payload);

        this.setState({
            commissionUserLookup: true,
        });
    };

    selectCommissionUser = (user: IUser) => {
        this.setState({
            selectedCommissionUser: user,
        });
    };

    renderCommissionedUser = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_commissions) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.Commission_User) {
                return null;
            }
        }

        const label = <OwLabel title={"commission_user"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;

        if (this.state.detailsEditMode) {
            return (
                <div className={"d-flex flex-column w-100"}>
                    <div>
                        <span className={this.state.labelWidth}>{label}</span>
                        <span>{this.props.order.Commission_User?.name}</span>
                    </div>
                    <div>
                        <Typeahead
                            isSelectableFn={() => true}
                            typeaheadApiFn={this.lookupCommissionUser}
                            clearTypeaheadCallback={this.clearCommissionUserTypeahead}
                            typeaheadItems={this.state.foundCommissionUsers}
                            titleProp={"name"}
                            subTitleProp={"email"}
                            selectedItemFn={this.selectCommissionUser}
                            selectedItemTitleProp={"name"}
                            clearTypeahead={this.state.clearCommissionUsersTypeahead}
                            scrollableList={true}
                        />
                    </div>
                </div>
            );
        } else {
            const display = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>{this.state.order.Commission_User?.name}</span>
                </div>
            );

            return display;
        }
    };

    renderShipmentMethodFn = (detail: IStandardRoomDetailItem, index: number) => {
        if (this.props.order.is_local_pickup || this.props.supplierModel.settings?.screens?.order_entry?.details_hidden.ship_via) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.qbo_ShipMethodRefValue) {
                return null;
            }
        }

        const label = <OwLabel title={"ship_via"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;

        if (this.state.detailsEditMode) {
            return (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    {this.props.supplierModel.ship_via_options ? (
                        <OwSelectOption
                            className={"w-100"}
                            name={"qbo_ShipMethodRefValue"}
                            options={this.props.supplierModel.ship_via_options}
                            titleProp={"label"}
                            valueProp={"value"}
                            selectedOption={this.state.order}
                            selectedOptionProp={"qbo_ShipMethodRefValue"}
                            hasSelectedOptionProp={true}
                            fn={(e: any) => {
                                this.rowUpdate(e, detail, index, "qbo_ShipMethodRefValue");
                            }}
                        />
                    ) : (
                        <OwInputWrapper
                            className={this.state.componentWidth}
                            name={"qbo_ShipMethodRefValue"}
                            fn={(e: any) => {
                                this.rowUpdate(e, detail, index, "qbo_ShipMethodRefValue");
                            }}
                            value={this.state.order.qbo_ShipMethodRefValue}
                        />
                    )}
                </div>
            );
        } else {
            const display = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>{this.state.order.qbo_ShipMethodRefValue}</span>
                </div>
            );

            return display;
        }
    };

    renderEstimateDate = (detail: IStandardRoomDetailItem, index: number) => {
        if (
            !this.props.supplierModel.Supplier_Integration.has_qbo ||
            this.props.supplierModel.settings.screens?.order_entry?.details_hidden.estimate_date
        ) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.qbo_TxnDate) {
                return null;
            }
        }

        const label = <OwLabel title={"estimate_date"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth}>{this.state.order.qbo_TxnDate}</span>
            </div>
        );

        return display;
    };

    renderShippingDate = (detail: IStandardRoomDetailItem, index: number) => {
        if (
            this.props.supplierModel.has_est_ship_date ||
            !this.props.supplierModel.has_shipments ||
            this.props.supplierModel.settings.screens?.order_entry?.details_hidden.shipping_date
        ) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.ship_date) {
                return null;
            }
        }

        const label = <OwLabel title={"shipping_date"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;

        if (this.state.detailsEditMode) {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwDateInput
                            selectedDate={this.state.order.ship_date}
                            isUTC={true}
                            fn={(date: Moment) => {
                                // date.utc();
                                this.rowUpdate(date, detail, index, "ship_date", undefined, true);
                            }}
                        />
                    </span>
                </div>
            );

            return edit;
        } else {
            const display = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>{UserService.parseDate(this.state.order.ship_date)}</span>
                </div>
            );

            return display;
        }
    };

    renderEstShipDate = (detail: IStandardRoomDetailItem, index: number) => {
        if (
            !this.props.supplierModel.has_est_ship_date ||
            this.props.supplierModel.settings?.screens?.order_entry?.details_hidden.est_ship_date
        ) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.estimated_shipping_at) {
                return null;
            }
        }

        const label = <OwLabel title={"est_ship_date"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;

        if (this.state.detailsEditMode) {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwDateInput
                            selectedDate={this.state.order.estimated_shipping_at}
                            isUTC={true}
                            fn={(date: Moment) => {
                                // date.utc();
                                this.rowUpdate(date, detail, index, "estimated_shipping_at", undefined, true);
                            }}
                        />
                    </span>
                </div>
            );

            return edit;
        } else {
            const display = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>{UserService.parseDate(this.state.order.estimated_shipping_at)}</span>
                </div>
            );

            return display;
        }
    };

    renderDeliveryDate = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_bill_of_lading) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.delivery_date?.length) {
                return null;
            }
        }

        const label = <OwLabel title={"delivery_date"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;

        if (this.state.detailsEditMode) {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwDateInput
                            selectedDate={this.state.order.delivery_date}
                            isUTC={true}
                            fn={(date: Moment) => {
                                // date.utc();
                                this.rowUpdate(date, detail, index, "delivery_date", undefined, true);
                            }}
                        />
                    </span>
                </div>
            );

            return edit;
        } else {
            const display = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>{UserService.parseDate(this.state.order.delivery_date)}</span>
                </div>
            );

            return display;
        }
    };

    renderQuoteExpDate = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.userModel.isSupplierUser) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.quote_exp_date) {
                return null;
            }
        }

        const label = <OwLabel title={"exp_date"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;

        if (this.state.detailsEditMode) {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwDateInput
                            selectedDate={this.state.order.quote_exp_date}
                            isUTC={true}
                            fn={(date: Moment) => {
                                // date.utc();
                                this.rowUpdate(date, detail, index, "quote_exp_date", undefined, true);
                            }}
                        />
                    </span>
                </div>
            );

            return edit;
        } else {
            const display = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>{UserService.parseDate(this.state.order.quote_exp_date)}</span>
                </div>
            );

            return display;
        }
    };

    renderOrderCategory = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.Category) {
                return null;
            }
        }

        const label = <OwLabel title={"order_category"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;

        if (this.state.detailsEditMode) {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwSelectOption
                        name={"category_id"}
                        valueProp={"id"}
                        titleProp={"name"}
                        options={this.state.orderCategories}
                        selectedOption={this.state.order}
                        selectedOptionProp={"category_id"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, "category_id", undefined);
                        }}
                        showBlankFirst={true}
                    />
                </div>
            );

            return edit;
        } else {
            const display = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>{this.state.order.Category?.name || ""}</span>
                </div>
            );

            return display;
        }
    };

    renderOrderDueDate = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.due_date) {
                return null;
            }
        }

        const label = <OwLabel title={"due_date"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth}>{UserService.parseUTCDate(this.state.order.due_date)}</span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwDateInput
                            selectedDate={this.state.order.due_date}
                            isUTC={true}
                            fn={(date: Moment) => {
                                // date.utc();
                                this.rowUpdate(date, detail, index, "due_date", undefined, true);
                            }}
                        />
                    </span>
                </div>
            );

            return edit;
        }
    };

    renderOrderCancelDate = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.cancel_date) {
                return null;
            }
        }

        const label = <OwLabel title={"cancel_date"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth}>{UserService.parseUTCDate(this.state.order.cancel_date)}</span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwDateInput
                            selectedDate={this.state.order.cancel_date}
                            isUTC={true}
                            fn={(date: Moment) => {
                                // date.utc();
                                this.rowUpdate(date, detail, index, "cancel_date", undefined, true);
                            }}
                        />
                    </span>
                </div>
            );

            return edit;
        }
    };

    renderOrderDoNotShipBeforeDate = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.do_not_ship_before_date) {
                return null;
            }
        }

        const label = <OwLabel title={"do_not_ship_before_date"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth}>{UserService.parseDate(this.state.order.do_not_ship_before_date)}</span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwDateInput
                            selectedDate={this.state.order.do_not_ship_before_date}
                            isUTC={true}
                            fn={(date: Moment) => {
                                // date.utc();
                                this.rowUpdate(date, detail, index, "do_not_ship_before_date", undefined, true);
                            }}
                        />
                    </span>
                </div>
            );

            return edit;
        }
    };

    renderInternalNote = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.internal_note) {
                return null;
            }
        }

        const label = <OwLabel title={"internal_note"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span className={this.state.componentWidth}>{this.state.order.internal_note}</span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span className={this.state.componentWidth}>
                        <OwTextArea
                            name={"internal_note"}
                            fn={(e: any) => {
                                this.rowUpdate(e, detail, index, "internal_note");
                            }}
                            value={this.state.order.internal_note}
                        />
                    </span>
                </div>
            );

            return edit;
        }
    };

    renderPO = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.po_no) {
                return null;
            }
        }

        const label = <OwLabel title={"po_no"} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.po_no}
            </div>
        );

        let poRequired = false;

        if (this.props.supplierModel.orders_require_po) {
            poRequired = true;
        }

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwInputWrapper
                        className={this.state.componentWidth}
                        name={"po_no"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, "po_no");
                        }}
                        value={this.state.order.po_no}
                        isRequired={poRequired}
                    />
                </div>
            );

            return edit;
        }
    };

    renderDetailSetting = (detail: IStandardRoomDetailItem, index: number) => {
        const value = _.get(this.state.order, `Order_Detail[${detail.prop}]`);

        if (!this.state.viewAllDetails) {
            if (!value) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {value}
            </div>
        );

        detail.isDetailsProp = true;

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwInputWrapper
                        className={this.state.componentWidth}
                        name={detail.prop!}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        value={value}
                    />
                </div>
            );

            return edit;
        }
    };

    renderIsDropship = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_dropshipping) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.is_dropship) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.is_dropship ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"is_dropship"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={this.state.order.is_dropship}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderIsDefaultTemplate = (detail: IStandardRoomDetailItem, index: number) => {
        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.is_default_template ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (!this.state.viewAllDetails) {
            if (!this.state.order.is_default_template) {
                return null;
            }
        }

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"is_default_template"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={!!this.state.order.is_default_template}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderExpedited = (detail: IStandardRoomDetailItem, index: number) => {
        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.is_expedited ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (!this.state.viewAllDetails) {
            if (!this.state.order.is_expedited) {
                return null;
            }
        }

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"is_expedited"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={this.state.order.is_expedited}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderSupplier = (detail: IStandardRoomDetailItem, index: number) => {
        const label = (
            <OwLabel title={detail.title} noBottomMargin={true} className={" " + this.state.labelWidth} postText={":"} isBold={true} />
        );

        return (
            <div className={`col-12 ${this.state.mdColumns} mb-1`}>
                {label}
                {this.props.supplierModel.name}
            </div>
        );
    };

    renderDotCert = (detail: IStandardRoomDetailItem, index: number) => {
        if (this.props.supplierModel.guid !== SupplierGuidEnum.PREFORM) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.Order_Detail?.dot_cert) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-start"}>
                <span className={this.state.labelWidth}>{label}</span>
                <div>
                    <div>{this.state.order.Order_Detail?.dot_cert ? <i className={"text-success fas fa-check"} /> : "--"}</div>
                    {this.state.order.Order_Detail?.dot_cert ? (
                        <div>
                            <div>
                                <OwLabel title={"cert_contact"} postText={":"} />{" "}
                                {this.state.order.Order_Detail?.dot_cert_contact ? this.state.order.Order_Detail?.dot_cert_contact : "--"}
                            </div>
                            <div>
                                <OwLabel title={"cert_state"} postText={":"} />{" "}
                                {this.state.order.Order_Detail?.dot_cert_state ? this.state.order.Order_Detail?.dot_cert_state : "--"}
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-start"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <div className={"d-flex flex-column"}>
                        <div>
                            <OwCheckbox
                                className={""}
                                name={"dot_cert"}
                                fn={(e: any) => {
                                    this.rowUpdate(e, detail, index, detail.prop);
                                }}
                                checked={this.state.order.Order_Detail?.dot_cert}
                                truthyVal={true}
                                falsyVal={false}
                                noLabel={true}
                            />
                        </div>

                        {this.state.order.Order_Detail?.dot_cert ? (
                            <div>
                                <div>
                                    <OwLabel title={"cert_contact"} postText={":"} />{" "}
                                    <OwFnInput
                                        fn={(e: any) => this.rowUpdate(e, detail, index, "dot_cert_contact")}
                                        name={"dot_cert_contact"}
                                        value={this.state.order.Order_Detail?.dot_cert_contact}
                                    />
                                </div>
                                <div>
                                    <OwLabel title={"cert_state"} postText={":"} />{" "}
                                    <OwFnInput
                                        fn={(e: any) => this.rowUpdate(e, detail, index, "dot_cert_state")}
                                        name={"dot_cert_state"}
                                        value={this.state.order.Order_Detail?.dot_cert_state}
                                    />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            );

            return edit;
        }
    };

    renderAllowBackorders = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_backorders) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.allow_backorders) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.allow_backorders ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"allow_backorders"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={this.state.order.allow_backorders}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderAllowSubstitutions = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_backorders) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.allow_substitutions) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.allow_substitutions ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"allow_substitutions"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={this.state.order.allow_substitutions}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderIsLocalDelivery = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_local_delivery) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.is_local_delivery) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.is_local_delivery ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"is_local_delivery"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={this.state.order.is_local_delivery}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderIsNonInventoryOrder = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_noninventory_orders) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.is_noninventory_order) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.is_noninventory_order ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"is_noninventory_order"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={this.state.order.is_noninventory_order}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderShipSpeed = (detail: IStandardRoomDetailItem, index: number) => {
        if (this.state.order.order_source_id !== OrderSourceEnum.WAYFAIR) {
            return null;
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.ship_speed}
            </div>
        );

        return display;
    };

    renderShipCarrier = (detail: IStandardRoomDetailItem, index: number) => {
        if (this.state.order.order_source_id !== OrderSourceEnum.WAYFAIR) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.ship_carrier) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.ship_carrier}
            </div>
        );

        return display;
    };

    renderWayfairPackingSlipUrl = (detail: IStandardRoomDetailItem, index: number) => {
        if (this.state.order.order_source_id !== OrderSourceEnum.WAYFAIR) {
            return null;
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.wayfair_packing_slip_url ? (
                    <a target={"_blank"} href={this.state.order.wayfair_packing_slip_url} rel="noreferrer">
                        {this.state.order.wayfair_packing_slip_url}
                    </a>
                ) : null}
            </div>
        );

        return display;
    };

    renderIsLocalPickup = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_local_pickup) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.is_local_pickup) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.is_local_pickup ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"is_local_pickup"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={this.state.order.is_local_pickup}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderIsResidential = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.is_residential) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.is_residential ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"is_residential"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={this.state.order.is_residential}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderIsCommercial = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.is_commercial) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.is_commercial ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"is_commercial"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={this.state.order.is_commercial}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderIsLiftGateRequired = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.is_lift_gate_required) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.is_lift_gate_required ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"is_lift_gate_required"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={this.state.order.is_lift_gate_required}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderConsignment = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_consignment) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.is_consignment) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.is_consignment ? <i className={"text-success fas fa-check"} /> : "--"}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 align-items-center"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwCheckbox
                        className={""}
                        name={"is_consignment"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        checked={this.state.order.is_consignment}
                        truthyVal={true}
                        falsyVal={false}
                        noLabel={true}
                    />
                </div>
            );

            return edit;
        }
    };

    /**
     * This is a generic render function for Text Field Input
     *
     * @param detail
     * @param index
     */
    renderInputSetting = (detail: IStandardRoomDetailItem, index: number) => {
        const value = _.get(this.state.order, `${detail.prop}`);

        if (!this.state.viewAllDetails) {
            if (!value) {
                return null;
            }
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {_.get(this.state.order, `${detail.prop}`)}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwInputWrapper
                        className={this.state.componentWidth}
                        name={detail.prop!}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.prop);
                        }}
                        value={value}
                    />
                </div>
            );

            return edit;
        }
    };

    vendorTypeahead = (name: string) => {
        const payload: IGetVendorsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            queryString: `?name=${name}`,
            nameGuidOnly: true,
        };

        this.props.socket.emit(EndpointsEnum.VendorsGetVendors, payload);
    };

    onGetVendors = (data: IOnGetVendorsDTO) => {
        const vendors = data.supplierVendorTokens.map((token) => {
            return token.Vendor!;
        });

        this.setState({
            vendors,
        });
    };

    clearVendorTypeaheadFn = () => {
        this.setState({
            clearVendorTypeahead: false,
            vendors: [],
        });
    };

    renderVendor = (detail: IStandardRoomDetailItem, index: number) => {
        const label = (
            <OwLabel
                isBold={true}
                title={"vendor"}
                noBottomMargin={true}
                className={"me-1"}
                postText={":"}
                isSupplierVendorOverride={true}
                supplierModel={this.props.supplierModel}
            />
        );

        const vendorName = SupplierService.updateStringWithVendorOverride("vendors", this.props.supplierModel);

        const hasQbo = !!this.props.supplierModel.Supplier_Integration.has_qbo;
        const isQboConnected = !!this.state.order.Vendor?.Vendor_Integration?.qbo_CustomerId;

        const display = (
            <div className={"d-flex w-100 align-items-center"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.props.userModel.isSupplierUser ? (
                    <>
                        <Link to={`/${vendorName}?name=${this.state.order.Vendor?.name}`}>{this.state.order.Vendor?.name}</Link>
                        {hasQbo ? (
                            <div>
                                {!isQboConnected ? (
                                    <div className={"d-flex align-items-center"}>
                                        <i
                                            className={"fas fa-exclamation-triangle text-warning ms-2"}
                                            title={"Not Connected To QuickBooks Online"}></i>
                                        <img src={quickBooksIcon} height={16} title={"Not Connected To QuickBooks Online"} />
                                    </div>
                                ) : null}
                            </div>
                        ) : null}
                    </>
                ) : (
                    this.state.order.Vendor?.name
                )}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <Typeahead
                        outerWrapperClassName={"w-100"}
                        isSelectableFn={() => {
                            return true;
                        }}
                        typeaheadApiFn={this.vendorTypeahead}
                        clearTypeahead={this.state.clearVendorTypeahead}
                        clearTypeaheadCallback={this.clearVendorTypeaheadFn}
                        typeaheadItems={this.state.vendors}
                        scrollableList={true}
                        selectedItem={this.state.order.Vendor}
                        selectedItemFn={(e: IVendorModel) => {
                            const obj = { target: { value: e.id, name: "vendor_id" } };
                            this.rowUpdate(obj, detail, index, "vendor_id", undefined);
                        }}
                        titleProp={"name"}
                        subTitleProp={"customer_internal_id"}
                    />
                </div>
            );

            return edit;
        }
    };

    clearClientTypeaheadFn = () => {
        const order = this.state.order;

        // @ts-expect-error
        order.client_id = null;
        // @ts-expect-error
        order.Client = null;

        this.setState({
            order,
            clearClientTypeahead: false,
            clients: [],
        });
    };

    clearContactTypeaheadFn = () => {
        const order = this.state.order;

        // @ts-expect-error
        order.contact_id = null;
        // @ts-expect-error
        order.Contact = null;

        this.setState({
            order,
            clearContactTypeahead: false,
            contacts: [],
        });
    };

    getContacts = (name: string) => {
        if (this.state.order.Vendor) {
            const payload: IGetContactsDTO = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                vendorGuid: this.state.order.Vendor.guid,
                name,
            };

            this.props.socket.emit(EndpointsEnum.ContactsGetContacts, payload);

            this.setState({
                contactName: name,
            });
        }
    };

    onGetContacts = (data: IOnGetContactsDTO) => {
        this.setState({
            contacts: data.contacts,
        });
    };

    renderContact = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.Contact) {
                return null;
            }
        }

        const label = <OwLabel isBold={true} title={"contact"} noBottomMargin={true} className={"me-1"} postText={":"} />;

        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <div>
                    <div>{this.state.order.Contact?.name}</div>
                    <div>
                        <OwLabel title={"phone"} postText={":"} className={"me-2"} />
                        {this.state.order.Contact?.phone}
                    </div>
                </div>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <Typeahead
                        outerWrapperClassName={"w-100"}
                        isSelectableFn={() => {
                            return true;
                        }}
                        typeaheadApiFn={this.getContacts}
                        titleProp={"name"}
                        selectedItem={this.state.order.Contact}
                        selectedItemTitleProp={"name"}
                        typeaheadItems={this.state.contacts}
                        clearTypeaheadCallback={this.clearContactTypeaheadFn}
                        clearTypeahead={this.state.clearContactTypeahead}
                        selectedItemFn={(data: IContact) => {
                            const e: any = {
                                target: {
                                    value: data.id,
                                    name: "contact_id",
                                },
                            };

                            this.rowUpdate(e, detail, index, "contact_id", undefined);
                        }}
                        showCreateNew={true}
                        createNewFn={() => {
                            this.showCreateContactModal();
                        }}
                    />
                </div>
            );

            return edit;
        }
    };

    showCreateContactModal = () => {
        const modalComponent = (
            <CreateContactModal closeModalFn={this.closeModal} createContact={this.createContact} contactName={this.state.contactName} />
        );

        this.setState({
            modalComponent,
            modalIsOpen: true,
        });
    };

    createContact = (name: string, phone: string) => {
        const payload: ICreateContactDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.order.Vendor?.guid,
            contact: {
                name,
                phone,
                vendor_id: this.props.order.vendor_id,
                supplier_id: this.props.supplierModel.id,
            },
        };

        this.props.socket.emit(EndpointsEnum.ContactsCreateContact, payload);
    };

    onCreateContact = (data: IContact) => {
        const e: any = {
            target: {
                value: data.id,
                name: "contact_id",
            },
        };

        this.rowUpdate(e, {} as IStandardRoomDetailItem, 0, "contact_id", undefined);
    };

    getRoutes = (name: string) => {
        const payload: IGetRoutesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
        };

        this.props.socket.emit(EndpointsEnum.RoutesGetRoutes, payload);
    };

    onGetRoutes = (data: IOnGetRoutesDTO) => {
        this.setState({
            availableRoutes: data.routes,
        });
    };

    renderRoute = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_routes) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.order.Route) {
                return null;
            }
        }

        const label = <OwLabel isBold={true} title={"route"} noBottomMargin={true} className={"me-1"} postText={":"} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.Route?.name}
                {this.state.order.Route?.is_pickup ? <OwBadge title={"pickup"} bgColor={"bg-primary"} /> : null}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode || !this.state.isSupplierUser) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <Typeahead
                        outerWrapperClassName={"w-100"}
                        isSelectableFn={() => {
                            return true;
                        }}
                        typeaheadApiFn={this.getRoutes}
                        itemsRenderFn={(data: IRoute) => {
                            return (
                                <div>
                                    <div>
                                        {data.name}
                                        {data.is_pickup ? <OwBadge title={"pickup"} bgColor={"bg-primary"} /> : null}
                                    </div>
                                </div>
                            );
                        }}
                        titleProp={"name"}
                        selectedItem={this.state.order.Route}
                        selectedItemTitleProp={"name"}
                        typeaheadItems={this.state.availableRoutes}
                        selectedItemFn={(data: IRoute) => {
                            const e: any = {
                                target: {
                                    value: data.id,
                                    name: "route_id",
                                },
                            };

                            this.rowUpdate(e, detail, index, "route_id", undefined);
                        }}
                    />
                </div>
            );

            return edit;
        }
    };

    renderExchangeRate = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.props.supplierModel.has_currencies) {
            return null;
        }

        const catalogCurrency = this.props.order?.Catalog?.Currency;

        if (!catalogCurrency) {
            return null;
        }

        const orderCurrency = this.props.order?.Currency;

        if (!orderCurrency) {
            return null;
        }

        const label = <OwLabel title={detail.title} noBottomMargin={true} className={"me-1"} postText={":"} isBold={true} />;
        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.exchange_rate} {orderCurrency.name} / {catalogCurrency.name}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            return (
                <div className={"d-flex w-100"}>
                    <OwLabel title={"exchange_rate"} className={this.state.labelWidth} />
                    <OwInputWrapper
                        className={this.state.componentWidth}
                        name={"exchange_rate"}
                        fn={(e: any) => this.rowUpdate(e, detail, index, "exchange_rate")}
                        value={this.state.order.exchange_rate}
                    />
                </div>
            );
        }
    };

    cancelClientSidebar = (detail: IStandardRoomDetailItem, index: number, clientCreated?: IClient) => {
        if (clientCreated) {
            const e: any = {
                target: {
                    value: clientCreated.id,
                    name: "client_id",
                },
            };

            this.setState(
                {
                    clients: [clientCreated],
                },
                () => {
                    this.rowUpdate(e, detail, index, "client_id", undefined);
                }
            );
        }

        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);
    };

    createNewClient = (detail: IStandardRoomDetailItem, index: number) => {
        const clientSidebarComponent = (
            <ClientSidebar
                cancelFn={(clientCreated?: IClient) => {
                    this.cancelClientSidebar(detail, index, clientCreated);
                }}
                vendorModel={this.props.order.Vendor!}
            />
        );

        this.props.setSidebarComponent(clientSidebarComponent);
        this.props.toggleSidebar();
    };

    renderClient = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.Client) {
                return null;
            }
        }

        const label = <OwLabel isBold={true} title={"client"} noBottomMargin={true} className={"me-1"} postText={":"} />;

        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.Client?.name}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <Typeahead
                        outerWrapperClassName={"flex-grow"}
                        isSelectableFn={() => {
                            return true;
                        }}
                        typeaheadApiFn={this.getClients}
                        titleProp={"name"}
                        subTitleProp={"email"}
                        selectedItem={this.state.order.Client}
                        selectedItemTitleProp={"name"}
                        typeaheadItems={this.state.clients}
                        clearTypeaheadCallback={this.clearClientTypeaheadFn}
                        clearTypeahead={this.state.clearClientTypeahead}
                        selectedItemFn={(data: IClient) => {
                            const e: any = {
                                target: {
                                    value: data.id,
                                    name: "client_id",
                                },
                            };

                            this.rowUpdate(e, detail, index, "client_id", undefined);
                        }}
                        createNewFn={() => {
                            this.createNewClient(detail, index);
                        }}
                        showCreateNew={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderProject = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.Project) {
                return null;
            }
        }

        const label = <OwLabel isBold={true} title={"project"} noBottomMargin={true} className={"me-1"} postText={":"} />;

        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.Project?.name}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <OwSelectOption
                        valueProp={"id"}
                        titleProp={"name"}
                        name={"project_id"}
                        options={this.state.projects}
                        selectedOption={this.state.order}
                        selectedOptionProp={"project_id"}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, "project_id", undefined);
                        }}
                        showBlankFirst={true}
                    />
                </div>
            );

            return edit;
        }
    };

    renderSalesRep = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.Sales_Rep) {
                return null;
            }
        }

        const label = <OwLabel isBold={true} title={"sales_rep"} noBottomMargin={true} className={"me-1"} postText={":"} />;

        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.order.Sales_Rep?.name}
            </div>
        );

        return display;
    };

    removeTag = (tag: ITag) => {
        const tags = this.state.tags.filter((t) => t.id !== tag.id);

        const order = Object.assign({}, this.state.order);

        if (_.isNil(order.Order_Detail)) {
            // @ts-expect-error
            order.Order_Detail = {};
        }

        order.tags = tags.map((_tag) => _tag.id);

        this.setState(
            {
                order,
                tags,
            },
            () => {
                // this.rowUpdate(e, detail, index, "project_id", undefined);
                this.props.pendingChangesFn(true);
            }
        );
    };

    getTags = (name: string) => {
        const payload: IGetTagsDTO = {
            userToken: this.props.userModel.token,
            userGuid: this.props.userModel.guid,
            supplierGuid: this.props.supplierModel.guid,
            name,
        };

        this.props.socket.emit(EndpointsEnum.TagsGetTags, payload);
    };

    onGetTags = (data: IOnGetTagsDTO) => {
        this.setState({
            foundTags: data.tags,
        });
    };

    addTag = (selectedTag: ITag) => {
        const tag = this.state.foundTags.find((_tag) => _tag.id === selectedTag.id);

        if (tag) {
            const existingTags = this.state.tags || [];

            const tags = [...existingTags, tag];

            const order = this.state.order;
            order.tags = tags.map((_tag) => _tag.id);

            this.setState(
                {
                    order,
                    tags,
                    clearTagTypeahead: true,
                },
                () => {
                    this.props.pendingChangesFn(true);
                }
            );
        }
    };

    createNewTag = (name?: string) => {
        if (name?.length) {
            const payload: IProcessTagDTO = {
                userToken: this.props.userModel.token,
                userGuid: this.props.userModel.guid,
                supplierGuid: this.props.supplierModel.guid,
                tag: {
                    name,
                    is_order_tag: true,
                    supplier_id: this.props.supplierModel.id,
                },
            };

            this.props.socket.emit(EndpointsEnum.TagsProcessTag, payload);
        }
    };

    onProcessTag = (data: IOnProcessTagDTO) => {
        const existingTags = this.state.tags || [];

        if (data.tag) {
            const tags = [...existingTags, data.tag];

            const order = this.state.order;
            order.tags = tags.map((tag) => tag.id);

            this.setState(
                {
                    order,
                    tags,
                    clearTagTypeahead: true,
                },
                () => {
                    this.props.pendingChangesFn(true);
                }
            );
        }
    };

    clearTagTypeaheadFn = () => {
        this.setState({
            clearTagTypeahead: false,
            selectedTag: undefined,
            foundTags: [],
        });
    };

    renderTags = (detail: IStandardRoomDetailItem, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.tags.length) {
                return null;
            }
        }

        const label = <OwLabel isBold={true} title={"tags"} noBottomMargin={true} className={"me-1"} postText={":"} />;

        if (this.props.isReadOnly || !this.state.detailsEditMode || !this.props.userModel.isSupplierUser) {
            const display = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    {this.state.tags.map((tag) => {
                        return <OwBadge key={tag.guid} title={tag.name} bgColor={"bg-primary"} skipTranslate={true} />;
                    })}
                </div>
            );

            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <div className="d-flex flex-column w-70">
                        <div className={"w-100"}>
                            <Typeahead
                                wrapperClassName={"w-100"}
                                isSelectableFn={() => true}
                                typeaheadApiFn={this.getTags}
                                typeaheadItems={this.state.foundTags}
                                confirmAdd={true}
                                clearTypeaheadCallback={this.clearTagTypeaheadFn}
                                clearTypeahead={this.state.clearTagTypeahead}
                                selectedItem={this.state.selectedTag}
                                selectedItemFn={this.addTag}
                                titleProp={"name"}
                                showCreateNew={true}
                                createNewFn={this.createNewTag}
                            />
                        </div>
                        <div>
                            {this.state.tags.map((tag) => {
                                return (
                                    <div key={tag.guid} className={"badge d-inline-flex me-2 bg-primary"}>
                                        {tag.name}
                                        <i
                                            className={"fas fa-times ms-2 pointer"}
                                            onClick={() => {
                                                this.removeTag(tag);
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            );

            return edit;
        }
    };

    /**
     * Function To Setup The Order Details Section
     *
     * title                - The Name of the Detail that will be translated
     * prop                 - The object property holding the value to display/edit
     * subProp              - Is there a subProp to consider before the prop: order['subProp']['prop']
     * isDetailsProp        - is it a prop on: order['details']['props']
     * @returns {{prop: string, title: string, subProp: null}[]}
     */
    getStandardRoomDetail = (): {
        mainView: IStandardRoomDetailItem[];
        shippingView: IStandardRoomDetailItem[];
        customShippingDetail: IStandardRoomDetailItem[];
    } => {
        const roomDetail: IStandardRoomDetailItem[] = [
            {
                title: "po_no",
                prop: "po_no",
                subProp: null,
                renderFn: this.renderPO,
            },
        ];
        const shippingDetail: IStandardRoomDetailItem[] = [];
        const customShippingDetail: IStandardRoomDetailItem[] = [];

        const has_local_delivery = this.props.supplierModel.has_local_delivery || false;
        const has_local_pickup = this.props.supplierModel.has_local_pickup || false;
        const has_sample_orders = this.props.supplierModel.has_sample_orders || false;
        const has_noninventory_orders = this.props.supplierModel.has_noninventory_orders || false;

        if (has_noninventory_orders) {
            roomDetail.push({
                title: "non_inventory_order",
                prop: "is_noninventory_order",
                renderFn: this.renderIsNonInventoryOrder,
            });
        }

        if (has_local_delivery) {
            roomDetail.push({
                title: "local_delivery",
                prop: "is_local_delivery",
                renderFn: this.renderIsLocalDelivery,
            });
        }

        if (has_local_pickup) {
            roomDetail.push({
                title: "local_pickup",
                prop: "is_local_pickup",
                renderFn: this.renderIsLocalPickup,
            });
        }

        if (this.props.supplierModel.show_order_ship_to_flags) {
            roomDetail.push({
                title: "residential",
                prop: "is_residential",
                renderFn: this.renderIsResidential,
            });

            roomDetail.push({
                title: "commercial",
                prop: "is_commercial",
                renderFn: this.renderIsCommercial,
            });

            roomDetail.push({
                title: "lift_gate",
                prop: "is_lift_gate_required",
                renderFn: this.renderIsLiftGateRequired,
            });
        }

        if (this.props.supplierModel.has_backorders) {
            roomDetail.push({
                title: "allow_backorders",
                prop: "allow_backorders",
                renderFn: this.renderAllowBackorders,
            });

            roomDetail.push({
                title: "allow_substitutions",
                prop: "allow_substitutions",
                renderFn: this.renderAllowSubstitutions,
            });
        }

        if (this.props.supplierModel.has_rep_groups) {
            roomDetail.push({
                title: "rep_group",
                prop: "rep_group",
                renderFn: this.renderRepGroup,
            });
        }

        let isSupplierUser = false;
        let isAdmin = false;

        if (this.props.userModel) {
            if (this.props.userModel.isSupplierUser) {
                isSupplierUser = true;
            }

            if (this.props.userModel.userType && this.props.userModel.userType.id === UserTypesEnum.ADMIN) {
                isAdmin = true;
            }
        }

        // TODO - Determine if we need to refactor this to allow a non-admin to edit?
        if (has_sample_orders && isSupplierUser && isAdmin) {
            // If the user is a supplier user
            roomDetail.push({
                title: "Is Sample",
                prop: "is_sample",
                type: RoomDetailItemTypeEnum.isBoolean,
            });
        }

        // RDHC
        // if (this.props.supplierModel.guid !== "649b5601-486e-4ce4-b6bc-34997993f8eb") {
        roomDetail.push({
            renderFn: this.renderDescription,
            title: "description",
            prop: "description",
            type: RoomDetailItemTypeEnum.isTextArea,
            className: "w-50",
        });

        roomDetail.push({
            renderFn: this.renderTags,
            title: "tags",
            prop: "tags",
            type: RoomDetailItemTypeEnum.isTextArea,
            className: "w-50",
        });
        // }

        if (isSupplierUser && isAdmin) {
            roomDetail.push({
                renderFn: this.renderUser,
                title: "user",
                prop: "user",
                type: RoomDetailItemTypeEnum.staticText,
                className: "w-50",
            });

            if (this.props.supplierModel.has_multi_workflows) {
                roomDetail.push({
                    renderFn: this.renderWorkflow,
                    title: "workflow",
                    prop: "",
                    type: RoomDetailItemTypeEnum.isSelectOption,
                    className: "w-50",
                });
            }
        }

        if (isSupplierUser && this.props.supplierModel.Supplier_Integration.has_taxjar) {
            roomDetail.push({
                renderFn: this.renderTaxJarExemption,
                title: "taxjar_exemption",
                prop: "taxjar_exemption_type",
                type: RoomDetailItemTypeEnum.isSelectOption,
                className: "w-50",
            });
        }

        if (isSupplierUser && isAdmin) {
            roomDetail.push({
                renderFn: this.renderQboInvoiceClass,
                title: "invoice_class",
                prop: "invoice_class",
                type: RoomDetailItemTypeEnum.isSelectOption,
                className: "w-50",
            });
        }

        if (this.props.supplierModel.has_spec_due_date && this.props.order.is_quote) {
            roomDetail.push({
                renderFn: this.renderSpecDueDate,
                title: "spec_due_date",
                prop: "spec_due_date",
                type: RoomDetailItemTypeEnum.isDate,
                className: "w-50",
            });
        }

        if (this.props.supplierModel.has_quote_exp && this.props.order.is_quote) {
            roomDetail.push({
                renderFn: this.renderQuoteExpDate,
                title: "quote_exp_date",
                prop: "quote_exp_date",
                type: RoomDetailItemTypeEnum.isDate,
                className: "w-50",
            });
        }

        roomDetail.push({
            renderFn: this.renderNote,
            title: "Note",
            prop: "note",
            type: RoomDetailItemTypeEnum.isTextArea,
            className: "w-50",
        });

        if (this.props.userModel && this.props.userModel.isSupplierUser) {
            // RDHC
            if (this.props.supplierModel.guid !== "649b5601-486e-4ce4-b6bc-34997993f8eb") {
                roomDetail.push({
                    renderFn: this.renderInternalNote,
                    title: "Internal Note",
                    prop: "internal_note",
                    type: RoomDetailItemTypeEnum.isTextArea,
                    className: "w-50",
                });
            }
        }

        if (this.props.supplierModel.has_order_categories) {
            roomDetail.push({
                renderFn: this.renderOrderCategory,
                title: "Order Category",
                prop: "order_category_id",
                type: RoomDetailItemTypeEnum.isTextArea,
                className: "w-50",
            });
        }

        if (this.props.supplierModel.has_commissions) {
            roomDetail.push({
                renderFn: this.renderCommissionedUser,
                title: "Commission User",
                prop: "",
                type: RoomDetailItemTypeEnum.staticText,
            });
        }

        if (this.props.supplierModel.Supplier_Integration.has_qbo) {
            roomDetail.push({
                renderFn: this.renderShipmentMethodFn,
                title: "Ship Method",
                prop: "",
                type: RoomDetailItemTypeEnum.staticText,
            });

            if (this.props.supplierModel.Supplier_Integration.has_qbo) {
                roomDetail.push({
                    renderFn: this.renderEstimateDate,
                    title: "Estimate Date",
                    prop: "",
                    type: RoomDetailItemTypeEnum.staticText,
                });

                if (!this.props.supplierModel.has_est_ship_date) {
                    roomDetail.push({
                        renderFn: this.renderShippingDate,
                        title: "Shipping Date",
                        prop: "",
                        type: RoomDetailItemTypeEnum.isDate,
                    });
                }
            }

            roomDetail.push({
                renderFn: this.renderEstShipDate,
                title: "Est. Shipping Date",
                prop: "",
                type: RoomDetailItemTypeEnum.isDate,
            });

            roomDetail.push({
                renderFn: this.renderQboCustomFieldsFn,
                title: "",
                prop: "",
                type: RoomDetailItemTypeEnum.staticText,
            });
        }

        if (this.props.supplierModel.has_order_cancel_date) {
            roomDetail.push({
                renderFn: this.renderOrderCancelDate,
                title: "Cancel Date",
                prop: "",
                type: RoomDetailItemTypeEnum.isDate,
            });
        }

        if (this.props.supplierModel.has_do_not_ship_before_date) {
            roomDetail.push({
                renderFn: this.renderOrderDoNotShipBeforeDate,
                title: "Do Not Ship Before Date",
                prop: "",
                type: RoomDetailItemTypeEnum.isDate,
            });
        }

        if (this.props.supplierModel.has_order_due_date) {
            roomDetail.push({
                renderFn: this.renderOrderDueDate,
                title: "Due Date",
                prop: "",
                type: RoomDetailItemTypeEnum.isDate,
            });
        }

        if (
            this.props.supplierModel.Supplier_Integration.has_shipstation &&
            this.props.userModel.isSupplierUser &&
            this.props.userModel.supplierUserToken?.user_type_id === UserTypesEnum.ADMIN
        ) {
            roomDetail.push({
                renderFn: this.renderShipstationCarrierCode,
                title: "Shipping Carrier",
                prop: "",
                type: RoomDetailItemTypeEnum.isSelectOption,
            });

            roomDetail.push({
                renderFn: this.renderShipstationServiceTypes,
                title: "Shipping Service",
                prop: "",
                type: RoomDetailItemTypeEnum.isSelectOption,
            });

            roomDetail.push({
                renderFn: this.renderShipstationPackageTypes,
                title: "Shipping Package",
                prop: "",
                type: RoomDetailItemTypeEnum.isSelectOption,
            });
        }

        if (this.props.supplierModel.has_projects) {
            roomDetail.push({
                title: "Project",
                prop: "Project",
                subProp: "name",
                type: RoomDetailItemTypeEnum.isSelectOption,
                className: "w-50",
                renderFn: this.renderProject,
            });
        }

        if (isSupplierUser && isAdmin && this.props.supplierModel.has_price_adjustments) {
            roomDetail.push({
                title: "Price Adjustment",
                prop: "price_adjustment",
                type: RoomDetailItemTypeEnum.isNumber,
            });
        }

        if (this.props.supplierModel.has_service_levels) {
            roomDetail.push({
                title: "Service Level",
                prop: "Service_Level",
                subProp: "id",
                renderFn: this.renderServiceLevels,
            });
        }

        shippingDetail.push({
            renderFn: this.renderShippingWarehouse,
            title: "Shipping Warehouse",
            prop: "shipping_warehouse_id",
            type: RoomDetailItemTypeEnum.isSelectOption,
            className: "w-50",
        });

        shippingDetail.push({
            renderFn: this.renderShippingInstructions,
            title: "Shipping Instructions",
            prop: "shipping_instructions",
            type: RoomDetailItemTypeEnum.isTextArea,
            className: "w-50",
        });

        shippingDetail.push({
            renderFn: this.renderQbdShipVia,
            title: "Ship Via",
            prop: "qbd_ship_via",
            type: RoomDetailItemTypeEnum.isSelectOption,
            className: "w-50",
        });

        shippingDetail.push({
            renderFn: this.renderShipTo,
            title: "ship_to",
            prop: "Ship_To",
            type: RoomDetailItemTypeEnum.isAddress,
            className: "w-50",
        });

        let isCatalogReadOnly = false;
        let isPriceGroupReadOnly = false;

        if (this.props.order.Order_Items.length) {
            isCatalogReadOnly = true;
            isPriceGroupReadOnly = true;
        }

        const catalogDetail: IStandardRoomDetailItem = {
            renderFn: this.renderCatalog,
            title: "Catalog",
            displayProp: "Catalog",
            displaySubProp: "name",
            prop: "catalogs",
            subProp: "name",
            type: RoomDetailItemTypeEnum.isSelectOption,
            isStateProp: true,
            isReadOnly: isCatalogReadOnly,
        };

        const priceGroupDetail: IStandardRoomDetailItem = {
            renderFn: this.renderPriceGroups,
            title: "Price Group",
            displayProp: "Price_Group",
            displaySubProp: "value",
            prop: "price_groups",
            subProp: "name",
            type: RoomDetailItemTypeEnum.isSelectOption,
            isStateProp: true,
            isReadOnly: isPriceGroupReadOnly,
        };

        if (this.props.order.category_id) {
            const categoryDetail: IStandardRoomDetailItem = {
                title: "Category",
                displayProp: "CategoryHierarchy",
                displaySubProp: "",
                type: RoomDetailItemTypeEnum.categoryViewOnly,
                isStateProp: true,
            };

            roomDetail.unshift(categoryDetail);
        }

        if (this.props.order.currency_id) {
            const categoryDetail: IStandardRoomDetailItem = {
                title: "exchange_rate",
                displayProp: "Exchange Rate",
                displaySubProp: "",
                type: RoomDetailItemTypeEnum.staticText,
                prop: "exchange_rate",
                isStateProp: true,
                isDetailsProp: false,
                renderFn: this.renderExchangeRate,
            };

            roomDetail.unshift(categoryDetail);
        }

        if (this.props.supplierModel.has_routes) {
            roomDetail.push({
                renderFn: this.renderRoute,
                title: "Route",
                prop: "route_id",
                type: RoomDetailItemTypeEnum.isSelectOption,
            });
        }

        if (this.props.order.is_template) {
            roomDetail.push({
                renderFn: this.renderIsDefaultTemplate,
                title: "default_template",
                prop: "is_default_template",
            });
        }

        if (this.props.supplierModel.has_rep_groups) {
            const repDetail: IStandardRoomDetailItem = {
                title: "Sales Rep",
                displayProp: "Sales_Rep",
                displaySubProp: "name",
                prop: "Sales_Rep",
                subProp: "name",
                type: RoomDetailItemTypeEnum.staticText,
                renderFn: this.renderSalesRep,
                isStateProp: false,
            };

            roomDetail.unshift(repDetail);
        }

        if (this.props.supplierModel.has_client_module) {
            const clientDetail: IStandardRoomDetailItem = {
                title: "Client",
                displayProp: "Client",
                displaySubProp: "name",
                prop: "clients",
                subProp: "name",
                type: RoomDetailItemTypeEnum.isSelectOption,
                isStateProp: true,
                renderFn: this.renderClient,
            };

            roomDetail.unshift(clientDetail);
        }

        if (this.props.supplierModel.has_contacts) {
            const contactDetail: IStandardRoomDetailItem = {
                title: "Contact",
                displayProp: "Contact",
                displaySubProp: "name",
                prop: "contacts",
                subProp: "name",
                type: RoomDetailItemTypeEnum.isSelectOption,
                isStateProp: true,
                renderFn: this.renderContact,
            };

            roomDetail.unshift(contactDetail);
        }

        if (this.state.isSupplierUser && this.props.userModel) {
            const isRestrictedUser =
                this.props.userModel.supplierUserToken?.access_type_id === systemConst.accessTypes.RESTRICTED ? true : false;

            if (isRestrictedUser && !_.isNil(this.props.userModel.supplierUserToken?.price_group_id)) {
                priceGroupDetail.isReadOnly = true;
            }

            roomDetail.unshift(priceGroupDetail);

            if (isRestrictedUser && !_.isNil(this.props.userModel.supplierUserToken?.catalog_id)) {
                catalogDetail.isReadOnly = true;
            }

            roomDetail.unshift(catalogDetail);

            roomDetail.unshift({
                renderFn: this.renderVendor,
                title: "Vendor",
                prop: "vendors",
                subProp: "name",
                displayProp: "Vendor",
                displaySubProp: "name",
                type: RoomDetailItemTypeEnum.isSelectOption,
                isStateProp: true,
                isSupplierVendorOverride: true,
            });
        } else {
            if (!_.isNil(this.state.order)) {
                if (!_.isNil(this.state.order.Vendor) && !_.isNil(this.state.order.Vendor.price_group_id)) {
                    priceGroupDetail.isReadOnly = true;
                }

                if (!this.props.supplierModel.hide_vendor_price_group_select) {
                    roomDetail.unshift(priceGroupDetail);
                }

                if (!_.isNil(this.state.order.Vendor) && this.state.order.Vendor.lock_catalog_id) {
                    catalogDetail.isReadOnly = true;
                }

                roomDetail.unshift(catalogDetail);
            }
        }

        if (!_.isString(this.props.supplierModel.settings) && this.props.supplierModel.settings.order_details) {
            for (const detail of this.props.supplierModel.settings.order_details) {
                roomDetail.push({
                    renderFn: this.renderDetailSetting,
                    title: detail,
                    prop: detail,
                    isDetailsProp: true,
                });
            }
        }

        if (this.props.supplierModel.has_third_party_order_ref) {
            roomDetail.push({
                renderFn: this.renderInputSetting,
                title: "third_party_order_ref",
                prop: "third_party_order_ref",
            });
        }

        if (this.props.supplierModel.has_expedited) {
            roomDetail.push({
                renderFn: this.renderExpedited,
                title: "is_expedited",
                prop: "is_expedited",
            });
        }

        if (this.props.supplierModel.has_dropshipping) {
            roomDetail.push({
                renderFn: this.renderIsDropship,
                title: "is_dropship",
                prop: "is_dropship",
            });
        }

        if (this.props.supplierModel.has_consignment) {
            roomDetail.push({
                renderFn: this.renderConsignment,
                title: "is_consignment",
                prop: "is_consignment",
            });
        }

        if (this.props.supplierModel.has_customer_module) {
            roomDetail.push({
                renderFn: this.renderAttachedUsers,
                title: "attached_users",
                prop: "attached_users",
            });
        }

        if (this.props.supplierModel.has_bill_of_lading) {
            roomDetail.push({
                renderFn: this.renderInputSetting,
                title: "shipping_method",
                prop: "shipping_method",
            });

            roomDetail.push({
                renderFn: this.renderDeliveryDate,
                title: "delivery_eta",
                prop: "delivery_eta",
                type: RoomDetailItemTypeEnum.isDate,
            });
        }

        if (this.state.order.order_source_id === OrderSourceEnum.WAYFAIR) {
            roomDetail.push({
                renderFn: this.renderShipSpeed,
                title: "ship_speed",
                prop: "",
            });

            roomDetail.push({
                renderFn: this.renderShipCarrier,
                title: "ship_carrier",
                prop: "",
            });

            roomDetail.push({
                renderFn: this.renderWayfairPackingSlipUrl,
                title: "packing_slip_url",
                prop: "",
            });
        }

        if (this.props.supplierModel.guid === SupplierGuidEnum.PREFORM) {
            roomDetail.push({
                renderFn: this.renderDotCert,
                title: "dot_cert",
                prop: "dot_cert",
                isDetailsProp: true,
            });
        }

        if (this.props.supplierModel.guid === SupplierGuidEnum.PANASONIC_CA) {
            roomDetail.push({
                renderFn: this.renderSupplier,
                title: "reseller",
                prop: "reseller",
            });
        }

        return { mainView: roomDetail, shippingView: shippingDetail, customShippingDetail };
    };

    getDetailItems = (): {
        mainView: IStandardRoomDetailItem[];
        shippingView: IStandardRoomDetailItem[];
        customShippingDetail: IStandardRoomDetailItem[];
    } => {
        const STANDARD = 1;

        if (this.props.order.order_item_type_id === STANDARD) {
            return this.getStandardRoomDetail();
        } else {
            return { mainView: [], shippingView: [], customShippingDetail: [] };
        }
    };

    parseDate = (date: any) => {
        if (!_.isString(date) || !date.length) {
            return;
        }

        return UserService.parseLastUpdated(date);
    };

    useClientAddressFn = (useAddress: boolean) => {
        if (useAddress) {
            const client = this.state.clients.find((client) => {
                return this.state.order.client_id === client.id;
            });

            if (client) {
                const order = this.state.order;

                // @ts-expect-error
                order.Ship_To = {
                    address_line_one: _.get(client.Ship_To, "address_line_one", ""),
                    address_line_two: _.get(client.Ship_To, "address_line_two", ""),
                    address_line_three: _.get(client.Ship_To, "address_line_three", ""),
                    city: _.get(client.Ship_To, "city", ""),
                    state: _.get(client.Ship_To, "state", ""),
                    postal_code: _.get(client.Ship_To, "postal_code", ""),
                    country: _.get(client.Ship_To, "country", ""),
                    phone: _.get(client.Ship_To, "phone", ""),
                    fax: _.get(client.Ship_To, "fax", ""),
                    name: client.name,
                    company_name: "",
                };

                this.setState(
                    {
                        order,
                    },
                    () => {
                        this.closeModal();
                    }
                );
            }
        } else {
            this.closeModal();
        }
    };

    updateEntireShipTo = (address: IAddress | INewAddress) => {
        const order = Object.assign({}, this.state.order);

        if (_.isNil(order.Order_Detail)) {
            // @ts-expect-error
            order.Order_Detail = {};
        }

        // @ts-expect-error
        order.Ship_To = {
            ...address,
        };

        this.setState(
            {
                order,
            },
            () => {
                this.props.pendingChangesFn(true);
            }
        );
    };

    rowUpdate = (e: any, detail: IStandardRoomDetailItem, index: number, prop?: string, subProp?: string | null, isUTC?: boolean) => {
        console.log(e, detail, index, prop, subProp, isUTC);

        let value: any;

        switch (detail.type) {
            case RoomDetailItemTypeEnum.isDate:
                if (isUTC) {
                    value = e ? moment(e.format("YYYY-MM-DD"), ["YYYY-MM-DD"]) : "";
                } else {
                    value = e ? e.format("YYYY-MM-DD") : "";
                }

                break;

            case RoomDetailItemTypeEnum.isBoolean:
                value = e.target.checked;
                break;

            default:
                value = e.target.value;
                break;
        }

        const order = Object.assign({}, this.state.order);

        if (_.isNil(order.Order_Detail)) {
            // @ts-expect-error
            order.Order_Detail = {};
        }

        if (prop && detail.type !== RoomDetailItemTypeEnum.isAddress) {
            if (!_.isNil(subProp)) {
                if (detail.isDetailsProp) {
                    // @ts-expect-error
                    order.Order_Detail[prop][subProp] = value;
                    order.details[prop][subProp] = value;
                } else {
                    // @ts-expect-error
                    order[prop][subProp] = value;
                }
            } else {
                if (detail.isDetailsProp) {
                    // @ts-expect-error
                    order.Order_Detail[prop] = value;
                    order.details[prop] = value;
                } else {
                    // @ts-expect-error
                    order[prop] = value;
                }
            }
        } else {
            const name = e.target.name;

            const addressType = name.substr(0, 7);
            const section = name.substr(8, name.length);

            let existingSection = _.get(this.state.order, `${addressType}`, {});

            if (_.isNil(existingSection)) {
                existingSection = {};
            }

            // @ts-expect-error
            order[addressType] = existingSection;

            // @ts-expect-error
            order[addressType][section] = value;
        }

        let priceGroups = this.state.priceGroups;

        if (prop === "catalog_id") {
            let foundCatalog: ICatalog | undefined;

            _.each(this.state.catalogs, (catalog: ICatalog) => {
                if (Number(catalog.id) === Number(value)) {
                    foundCatalog = catalog;
                }
            });

            if (foundCatalog) {
                priceGroups = foundCatalog.Price_Groups || [];
            }

            if (priceGroups.length === 1) {
                order.price_group_id = priceGroups[0].id;
            } else {
                // @ts-expect-error
                order.price_group_id = "";
            }
        }

        let modalComponent: any = null;
        let modalIsOpen = false;
        let modalHeight = this.state.modalHeight;

        if (prop === "client_id") {
            if (this.state.order.client_id !== order.client_id) {
                const client = this.state.clients?.find((_client) => {
                    return _client.id === order.client_id;
                });

                // show the use client address modal component
                modalComponent = (
                    <UseClientAddressModal
                        closeModalFn={this.closeModal}
                        socket={this.props.socket}
                        notifyFn={this.props.notifyFn}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        clientModel={client!}
                        orderModel={this.state.order}
                        useClientAddressFn={this.useClientAddressFn}
                    />
                );

                modalIsOpen = true;
                modalHeight = "25rem";
            }
        }

        this.setState(
            {
                order,
                priceGroups,
                modalComponent,
                modalIsOpen,
                modalHeight,
            },
            () => {
                // console.log("order: ", this.state.order);
                this.props.pendingChangesFn(true);
            }
        );
    };

    cancelModal = () => {
        this.setState({
            modalComponent: null,
            modalIsOpen: false,
        });
    };

    acceptBatchRemoval = () => {
        this.setState(
            {
                modalComponent: null,
                modalIsOpen: false,
            },
            () => {
                this.props.updateOrderEntryDetail(this.state.order);

                this.toggleDetailsEditMode();
            }
        );
    };

    updateOrderEntryDetail = () => {
        if (this.props.supplierModel.orders_require_po) {
            if (!this.state.order.po_no || !this.state.order.po_no.trim().length) {
                const notification: INotification = {
                    message: "po_number_required",
                    level: NotificationLevelEnum.error,
                    position: NotificationPositionEnum.bc,
                };

                this.props.notifyFn(null, notification);
                return null;
            }
        }

        if (this.props.supplierModel.has_service_levels) {
            if (this.state.order.service_level_id !== this.state.originalServiceLevelId) {
                if (this.props.order.order_batch_id) {
                    const modalComponent = (
                        <OwContinueConfirmModal
                            message={"this_will_remove_order_from_batch"}
                            acceptFn={this.acceptBatchRemoval}
                            cancelFn={this.cancelModal}
                        />
                    );

                    this.setState({
                        modalIsOpen: true,
                        modalComponent,
                    });

                    return;
                }
            }
        }

        const order: Partial<IUpdateOrderEntryDetailDTO> = {
            ...this.state.order,
        };

        if (this.state.save_address_to_vendor) {
            order.save_address_to_vendor = true;
        }

        if (this.state.qbo_InvoiceClassRef) {
            order.qbo_InvoiceClassRef = this.state.qbo_InvoiceClassRef;
        }

        if (this.state.assignedUsers) {
            order.assignedUsers = this.state.assignedUsers.map((user) => {
                return { guid: user.guid };
            });
        }

        if (this.state.selectedUser) {
            order.user_id = this.state.selectedUser.id;
        }

        if (this.state.selectedCommissionUser) {
            order.commission_user_id = this.state.selectedCommissionUser.id;
        }

        if (this.props.supplierModel.has_rep_groups) {
            order.rep_group_id = this.state.selectedRepGroup?.id;
        }

        if (this.state.clearRepGroup) {
            order.clearRepGroup = true;
        }

        if (this.props.userModel.isSupplierUser && this.props.userModel.supplierUserToken?.id === UserTypesEnum.ADMIN) {
            order.workflow_id = this.state.workflow_id ? Number(this.state.workflow_id) : null;
        }

        if (this.state.qbd_ship_via) {
            order.qbd_ship_via = this.state.qbd_ship_via;
        }

        if (this.state.workflow_id) {
            order.workflow_id = this.state.workflow_id;
        }

        console.log("dot_cert_contact: ", this.state.order.Order_Detail?.dot_cert_contact);
        if (this.state.order.Order_Detail?.dot_cert_contact) {
            order.dot_cert_contact = this.state.order.Order_Detail?.dot_cert_contact;
            order.details!.dot_cert_contact = this.state.order.Order_Detail?.dot_cert_contact;
        }

        if (this.state.order.Order_Detail?.dot_cert_state) {
            order.dot_cert_state = this.state.order.Order_Detail?.dot_cert_state;
            order.details!.dot_cert_state = this.state.order.Order_Detail?.dot_cert_state;
        }

        if (!_.isNil(this.state.order.Order_Detail?.dot_cert)) {
            order.dot_cert = this.state.order.Order_Detail?.dot_cert;
            order.details!.dot_cert = this.state.order.Order_Detail?.dot_cert;
        }

        if (!_.isNil(this.state.order.exchange_rate)) {
            order.exchange_rate = this.state.order.exchange_rate;
        }

        this.props.updateOrderEntryDetail(order, true);

        this.toggleDetailsEditMode();
    };

    _getDatePickerMoment = (date_str: string) => {
        if (!_.isNil(date_str) && date_str.length) {
            const datePickerMoment = moment(date_str, "YYYY-MM-DDTHH:mm:ss");

            return datePickerMoment;
        } else {
            return moment();
        }
    };

    updateShipTo = (e: any, addresses: IAddress[]) => {
        const value = e.target.value;
        const name = e.target.name;

        const order = this.state.order;
        const Ship_To = order.Ship_To;

        let setShipTo: IAddress | undefined;

        for (const address of addresses) {
            if (Number(address.id) === Number(value)) {
                setShipTo = address;
            }
        }

        if (setShipTo && Ship_To) {
            Ship_To.name = setShipTo.name;
            Ship_To.company_name = setShipTo.company_name;
            Ship_To.address_line_one = setShipTo.address_line_one;
            Ship_To.address_line_two = setShipTo.address_line_two;
            Ship_To.address_line_three = setShipTo.address_line_three;
            Ship_To.city = setShipTo.city;
            Ship_To.state = setShipTo.state;
            Ship_To.postal_code = setShipTo.postal_code;
            Ship_To.country = setShipTo.country;
            Ship_To.phone = setShipTo.phone;
            Ship_To.fax = setShipTo.fax;
            Ship_To.email = setShipTo.email;
            Ship_To.address_internal_id = setShipTo.address_internal_id;

            order.Ship_To = Ship_To;
        }

        this.setState(
            {
                order,
            },
            () => {
                this.props.pendingChangesFn(true);
            }
        );
    };

    getAddressDisplay = (detail: IStandardRoomDetailItem) => {
        if (!this.state.order) {
            return null;
        }

        if (this.state.order.order_source_id === OrderSourceEnum.ORDERWERKS) {
            let hasShipTo = true;

            if (!this.props.order.Ship_To?.city && !this.props.order.Ship_To?.state && !this.props.order.Ship_To?.postal_code) {
                hasShipTo = false;
            }

            if (!_.isNil(this.state.order.Ship_To)) {
                return (
                    <div className={"d-flex"}>
                        {this.props.supplierModel.has_google_maps && hasShipTo ? (
                            <OwGoogleStaticMap
                                address={this.props.order.Ship_To!}
                                size={"120x120"}
                                markerSize={GoogleMapsMarkerSizeEnum.TINY}
                                className={"me-2"}
                            />
                        ) : null}
                        <AddressDisplay
                            prefix={"Ship_To."}
                            showName={true}
                            address={this.props.order}
                            showCompanyName={true}
                            showPhone={true}
                            hideEmail={true}
                            hideFax={true}
                            hideMobile={true}
                        />
                    </div>
                );
            } else {
                return (
                    <div className={"d-flex"}>
                        {this.props.supplierModel.has_google_maps && this.state.order.Vendor?.Ship_To ? (
                            <OwGoogleStaticMap
                                address={this.state.order.Vendor.Ship_To}
                                size={"120x120"}
                                markerSize={GoogleMapsMarkerSizeEnum.TINY}
                                className={"me-2"}
                            />
                        ) : null}
                        <AddressDisplay
                            address={this.state.order.Vendor}
                            prefix={"Ship_To."}
                            showName={true}
                            showCompanyName={true}
                            showPhone={true}
                            hideFax={true}
                            hideMobile={true}
                            hideEmail={true}
                        />
                    </div>
                );
            }
        } else {
            const addressShipTo = this.state.order?.Ship_To || this.state.order?.Client?.Ship_To;

            return (
                <div className={"d-flex"}>
                    {this.props.supplierModel.has_google_maps ? (
                        <OwGoogleStaticMap
                            address={addressShipTo || {}}
                            size={"120x120"}
                            markerSize={GoogleMapsMarkerSizeEnum.TINY}
                            className={"me-2"}
                        />
                    ) : null}
                    <AddressDisplay address={addressShipTo} showName={true} />
                </div>
            );
        }
    };

    renderVendorAddressOption = (option: IAddress): string => {
        return `${option.company_name} ${option.address_line_one}, ${option.city} ${option.state}`;
    };

    cancelSidebar = () => {
        this.props.setSidebarComponent(null);
        this.props.toggleSidebar(false);
    };

    showAddressesSidebar = () => {
        // if its photo view mode, we need to show it in a modal

        if (this.props.isEcommerceView) {
            const component = (
                <OrderAddressSidebar
                    orderModel={this.props.order}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    vendorModel={this.props.order.Vendor!}
                    socket={this.props.socket}
                    cancel={this.closeModal}
                    updateShipTo={this.updateShipTo}
                />
            );

            this.setState({
                modalComponent: component,
                modalIsOpen: true,
                modalHeight: "90%",
            });
        } else {
            const component = (
                <OrderAddressSidebar
                    orderModel={this.props.order}
                    userModel={this.props.userModel}
                    supplierModel={this.props.supplierModel}
                    vendorModel={this.props.order.Vendor!}
                    socket={this.props.socket}
                    cancel={this.cancelSidebar}
                    updateShipTo={this.updateShipTo}
                />
            );

            this.props.setSidebarComponent(component);
            this.props.toggleSidebar(true);
        }
    };

    getVendorAddresses = (name: string) => {
        const payload: IGetVendorAddressesDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.order.Vendor!.guid,
            queryString: `?name=${name}`,
            onlyNonAssignedAddresses: this.state.onlyNonAssignedAddresses,
        };

        this.props.socket.emit(EndpointsEnum.AddressGetVendorAddresses, payload);

        this.setState({
            performingVendorAddressLookup: true,
        });
    };

    onGetVendorAddresses = (data: IOnGetVendorAddressesDTO) => {
        if (this.state.performingVendorAddressLookup) {
            this.setState({
                foundVendorAddresses: data.addresses,
                performingVendorAddressLookup: false,
            });
        }
    };

    setOrderAddress = (data: IAddress, detail: IStandardRoomDetailItem, index: number) => {
        const e = {
            target: {
                value: data.id,
                name: "Ship_To",
            },
        };

        this.updateShipTo(e, this.state.foundVendorAddresses);
    };

    // shippingDetail.push({
    //                         renderFn: this.renderShipTo,
    //                         title: "ship_to",
    //                         prop: "Ship_To",
    //                         type: RoomDetailItemTypeEnum.isAddress,
    //                         className: "w-50",
    //                     });

    clearTypeaheadCallback = () => {
        this.setState({
            selectedAddress: undefined,
            clearTypeahead: false,
        });
    };

    handleChange = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checked" ? e.target.checked : e.target.value;
        const name = e.target.name;

        const state: any = {
            [name]: value,
        };

        this.setState(state, () => {
            if (name !== "onlyNonAssignedAddresses") {
                this.props.pendingChangesFn(true);
            }
        });
    };

    getAddressDetailView = (detail: IStandardRoomDetailItem, index: number) => {
        // TODO only allow editing if the user is a Supplier User for Supplier Guid
        let isDisabled = false;

        if (this.props.userModel && !this.props.userModel.isSupplierUser) {
            if (this.props.supplierModel && this.props.supplierModel.guid === "2a807afe-6a9e-4c47-a4fd-8d9e638415e4") {
                isDisabled = true;
            }
        }

        return (
            <div className={"d-flex flex-column"}>
                <div className={"mb-2"}>
                    <OwLabel title={"address_lookup"} isBold={true} isUnderline={true} />
                    <div>
                        <OwCheckbox
                            label={"hide_order_addresses"}
                            name={"onlyNonAssignedAddresses"}
                            fn={this.handleChange}
                            truthyVal={true}
                            falsyVal={false}
                            checked={this.state.onlyNonAssignedAddresses}
                        />
                    </div>
                    <Typeahead
                        isSelectableFn={() => {
                            return true;
                        }}
                        typeaheadApiFn={this.getVendorAddresses}
                        titleProp={"address_line_one"}
                        subTitleProp={"city"}
                        selectedItem={this.state.selectedAddress}
                        selectedItemTitleProp={"address_line_one"}
                        clearTypeahead={this.state.clearTypeahead}
                        clearTypeaheadCallback={this.clearTypeaheadCallback}
                        selectedItemFn={(data: IAddress) => {
                            this.setOrderAddress(data, detail, index);
                        }}
                        typeaheadItems={this.state.foundVendorAddresses}
                    />
                </div>
                <div className={"mb-1"}>
                    <OwButton title={"view_addresses"} fn={this.showAddressesSidebar} />
                </div>
                <div>
                    <OwCheckbox
                        isSupplierVendorOverride={true}
                        supplierModel={this.props.supplierModel}
                        name={"save_address_to_vendor"}
                        label={"save_address_to_vendor"}
                        fn={this.handleChange}
                        truthyVal={true}
                        falsyVal={false}
                        checked={this.state.save_address_to_vendor}
                    />
                </div>
                <AddressBlock
                    isDisabled={isDisabled}
                    showName={true}
                    showCompanyName={true}
                    showPhoneFax={true}
                    hideFax={true}
                    prefix={"Ship_To."}
                    address={this.state.order.Ship_To}
                    fn={(e: any) => {
                        this.rowUpdate(e, detail, index, detail.prop, detail.subProp);
                    }}
                    updateEntireAddressFn={this.updateEntireShipTo}
                />
            </div>
        );
    };

    /**
     * This function is what actually compiles all of the 'options' shown on the details tab panel in Order Entry
     *
     * @param detail
     * @param index
     * @private
     */
    _createDetailsView = (detail: IStandardRoomDetailItem, index: number) => {
        if (!detail.renderFn) {
            return;
        }

        const detailRendered = detail.renderFn(detail, index);

        if (detailRendered) {
            return (
                <div key={index} className={this.props.isEcommerceView ? "" : `col-12 ${this.state.mdColumns} mb-1`}>
                    {detailRendered}
                </div>
            );
        } else {
            return null;
        }
    };

    lmcContractOnly = (detail: IOrderDetailConfig): boolean => {
        let isVisible = true;

        switch (detail.title) {
            case "order_note":
            case "vendor":
            case "mill":
            case "product_mix":
                isVisible = this.props.order.Category?.name === "Contract";
                break;
        }

        return isVisible;
    };

    processIsVisibleFn = (detail: IOrderDetailConfig): boolean => {
        let isVisible = true;

        switch (detail.isVisibleFn) {
            case "lmcContractOnly":
                isVisible = this.lmcContractOnly(detail);
                break;
        }

        return isVisible;
    };

    buildProductMixFn = (detail: IOrderDetailConfig) => {
        const vendorSourceLocation = this.props.order.Vendor_Source_Location || { Catalog_Items: [] };

        let product_mix = "";

        const catalogItems = vendorSourceLocation.Catalog_Items || [];

        const items = catalogItems.map((item) => {
            return item.name;
        });

        product_mix = items.join(", ");

        return (
            <div className={`col-12 ${this.state.mdColumns} mb-1`}>
                <OwLabel title={"product_mix"} isBold={true} postText={":"} className={"me-2"} />
                {product_mix}
            </div>
        );
    };

    processRenderFn = (detail: IOrderDetailConfig, index: number): any => {
        switch (detail.renderFn) {
            case "buildProductMixFn":
                return this.buildProductMixFn(detail);

            case "renderAttachedUsers":
                return <div className={`col-12 ${this.state.mdColumns} mb-1`}>{this.renderAttachedUsers(detail)}</div>;

            case "renderSpecDueDate":
                return <div className={`col-12 ${this.state.mdColumns} mb-1`}>{this.renderSpecDueDate(detail)}</div>;

            case "renderSupplier":
                return this.renderSupplier(detail, index);

            case "renderShipToStreets":
                return this.renderShipToStreets(detail, index);
        }
    };

    lookupVendorUser = (str: string) => {
        const payload: ITypeaheadLookupByTokenTypeDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            vendorGuid: this.props.order.Vendor!.guid,
            tokenType: "ALL_USERS",
            name: str,
        };

        this.props.socket.emit(EndpointsEnum.TokenTypeaheadLookupByTokenType, payload);
    };

    onLookupVendorUser = (data: IOnTypeaheadLookupByTokenTypeDTO) => {
        const foundVendorUsers = data.results.map((result) => {
            return result.User!;
        });

        this.setState({
            foundVendorUsers,
        });
    };

    addAssignedUser = (user: IUser) => {
        const assignedUsers = this.state.assignedUsers;

        let userExists = false;

        for (const assignedUser of assignedUsers) {
            if (assignedUser.guid === user.guid) {
                userExists = true;
            }
        }

        if (!userExists) {
            assignedUsers.push(user);

            this.setState({
                assignedUsers,
            });
        } else {
            const notification: INotification = {
                message: "user_already_assigned",
                position: NotificationPositionEnum.bc,
                level: NotificationLevelEnum.error,
            };

            this.props.notifyFn(null, notification);
        }
    };

    removeAssignedUser = (user: IUser, index: number) => {
        const assignedUsers = this.state.assignedUsers;

        assignedUsers.splice(index, 1);

        this.setState({
            assignedUsers,
        });
    };

    clearSelectedAssignedUser = () => {
        this.setState({
            clearAssignedUserTypeahead: false,
            selectedAssignedUser: null,
        });
    };

    handleQbdShipViaChange = (shipVia: { title: string; value: string }) => {
        const qbdShipVia = (this.props.supplierModel.Supplier_Integration.qbd_ShipMethodOptions || [])
            .filter((item) => item.IsActive)
            .find((item) => item.ListID === shipVia.value);

        this.setState(
            {
                qbd_ship_via: qbdShipVia,
            },
            () => {
                this.props.pendingChangesFn(true);
            }
        );
    };

    renderQbdShipVia = (detail: IOrderDetailConfig) => {
        if (
            this.props.supplierModel.Supplier_Integration.has_qbd &&
            this.props.supplierModel.Supplier_Integration.qbd_show_ship_via_options
        ) {
            if (!this.state.viewAllDetails) {
                if (!this.state.order.qbd_ship_via) {
                    return null;
                }
            }

            const label = <OwLabel isBold={true} title={"ship_via"} noBottomMargin={true} className={"me-1"} postText={":"} />;

            const display = (
                <div className={"d-flex flex-row w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    {this.props.order.qbd_ship_via ? this.props.order.qbd_ship_via.Name : ""}
                </div>
            );

            if (this.props.isReadOnly || !this.state.detailsEditMode) {
                return display;
            } else {
                const qbdShipViaOptions = (this.props.supplierModel.Supplier_Integration.qbd_ShipMethodOptions || [])
                    .filter((item) => item.IsActive)
                    .map((item) => {
                        return {
                            value: item.ListID,
                            title: item.Name,
                        };
                    });

                return (
                    <div className={"mb-4"}>
                        <OwLabel
                            title={"ship_via"}
                            isBold={true}
                            showIsReqAsterik={!!this.props.supplierModel.require_accounts_select_warehouse}
                        />
                        <div>
                            <OwSelectOption
                                fn={this.handleQbdShipViaChange}
                                name={"qbd_ship_via"}
                                titleProp={"title"}
                                valueProp={"value"}
                                options={qbdShipViaOptions}
                                emitObject={true}
                                selectedOption={this.state.order}
                                selectedOptionProp={"qbd_ship_via"}
                            />
                        </div>
                    </div>
                );
            }
        }
    };

    renderAttachedUsers = (detail: IOrderDetailConfig): any => {
        if (this.props.supplierModel.settings?.screens?.order_entry?.details_hidden.assigned_users) {
            return null;
        }

        if (!this.state.viewAllDetails) {
            if (!this.state.assignedUsers.length) {
                return null;
            }
        }

        const label = <OwLabel isBold={true} title={"assigned_users"} noBottomMargin={true} className={"me-1"} postText={":"} />;

        const display = (
            <div className={"d-flex flex-column w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                {this.state.assignedUsers.map((assignedUser) => {
                    return (
                        <div key={assignedUser.guid}>
                            {assignedUser.name} - {assignedUser.email}
                        </div>
                    );
                })}
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 flex-column"}>
                    <div>
                        <span className={this.state.labelWidth}>{label}</span>
                        <div className={"position-relative"}>
                            <Typeahead
                                isSelectableFn={() => {
                                    return true;
                                }}
                                typeaheadApiFn={this.lookupVendorUser}
                                confirmAdd={true}
                                selectedItemFn={this.addAssignedUser}
                                selectedItem={this.state.selectedAssignedUser}
                                typeaheadItems={this.state.foundVendorUsers}
                                selectedItemTitleProp={"name"}
                                titleProp={"name"}
                                subTitleProp={"email"}
                                clearTypeahead={this.state.clearAssignedUserTypeahead}
                                clearTypeaheadCallback={this.clearSelectedAssignedUser}
                            />
                        </div>
                    </div>

                    <div className={"mt-2"}>
                        <OwObjectChips
                            chips={this.state.assignedUsers}
                            removeChip={this.removeAssignedUser}
                            context={ContextEnum.PRIMARY}
                            chipSize={ChipSizeEnum.XS}
                            titleProp={"name"}
                            subTitleProp={"email"}
                            isStacked={true}
                        />
                    </div>
                </div>
            );

            return edit;
        }
    };

    renderVendorSourceLocationEdit = (detail: IOrderDetailConfig, value: any, index: number) => {
        return (
            <div className={this.props.isEcommerceView ? "d-flex" : `d-flex w-100 ${this.state.mdColumns} col-12`}>
                <OwLabel
                    title={detail.title}
                    postText={":"}
                    className={"me-2"}
                    isBold={true}
                    supplierModel={this.props.supplierModel}
                    isSupplierVendorOverride={!!detail.isSupplierVendorOverride}
                />
                <span className={this.state.componentWidth}>
                    <OwSelectOption
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, "vendor_source_location_id");
                        }}
                        name={"vendor_source_location_id"}
                        options={this.state.vendorSourceLocations}
                        titleProp={"name"}
                        valueProp={"id"}
                        selectedOption={this.state.order}
                        selectedOptionProp={"vendor_source_location_id"}
                    />
                    {/*<OwTextArea*/}
                    {/*    name={detail.valueProp}*/}
                    {/*    fn={(e: any) => {*/}
                    {/*        this.rowUpdate(e, detail, index, detail.valueProp);*/}
                    {/*    }}*/}
                    {/*    value={value}*/}
                    {/*/>*/}
                </span>
            </div>
        );
    };

    lookupRepGroup = (name: string) => {
        const payload: IGetRepGroupsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            name,
        };

        this.props.socket.emit(EndpointsEnum.RepGroupGetRepGroups, payload);
    };

    onLookupRepGroup = (data: IOnGetRepGroupsDTO) => {
        this.setState({
            foundRepGroups: data.repGroups,
        });
    };

    assignRepGroup = (repGroup: IRepGroup) => {
        this.setState({
            selectedRepGroup: repGroup,
        });
    };

    clearSelectedRepGroup = () => {
        this.setState({
            selectedRepGroup: null,
            clearRepGroupTypeahead: false,
        });
    };

    clearRepGroup = (clearRepGroup: boolean) => {
        this.setState({
            clearRepGroup,
        });
    };

    lookupUser = (name: string) => {
        const payload: ITypeaheadLookupByTokenTypeDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            tokenType: TokenTypesEnum.SUPPLIER_USER,
            name,
        };

        this.props.socket.emit(EndpointsEnum.TokenTypeaheadLookupByTokenType, payload);
    };

    onTypeaheadLookupByTokenType = (data: IOnTypeaheadLookupByTokenTypeDTO) => {
        const foundUsers = data.results.map((token) => {
            return token.User!;
        });

        if (this.state.commissionUserLookup) {
            this.setState({
                foundCommissionUsers: foundUsers,
                commissionUserLookup: false,
            });
        } else {
            this.setState({
                foundUsers,
            });
        }
    };

    assignUser = (user: IUser) => {
        this.setState({
            selectedUser: user,
        });
    };

    clearSelectedUser = () => {
        this.setState({
            selectedUser: null,
            clearUserTypeahead: false,
        });
    };

    renderQboInvoiceClass = (detail: IOrderDetailConfig, value: any, index: number) => {
        if (
            this.props.userModel.isSupplierUser &&
            this.props.userModel.supplierUserToken?.id === UserTypesEnum.ADMIN &&
            this.props.supplierModel.Supplier_Integration.has_qbo &&
            this.props.supplierModel.Supplier_Integration.qbo_using_classes
        ) {
            if (!this.state.viewAllDetails) {
                if (!this.state.order.qbo_InvoiceClassRef) {
                    return null;
                }
            }

            const label = <OwLabel isBold={true} title={"invoice_class"} noBottomMargin={true} className={"me-1"} postText={":"} />;

            let invoiceClassName = "";

            if (this.state.qboClasses?.length) {
                for (const qboClass of this.state.qboClasses) {
                    if (qboClass.Id === this.state.qbo_InvoiceClassRef) {
                        invoiceClassName = qboClass.Name;
                    }
                }
            }

            const display = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <span>{invoiceClassName}</span>
                </div>
            );

            if (this.props.isReadOnly || !this.state.detailsEditMode) {
                return display;
            } else {
                const edit = (
                    <div className={"d-flex w-100 flex-column"}>
                        <div>
                            <span className={this.state.labelWidth}>{label}</span>
                            <div className={"position-relative"}>
                                <OwSelectOption
                                    name={"qbo_InvoiceClassRef"}
                                    fn={this.handleChange}
                                    options={this.state.qboClasses}
                                    titleProp={"Name"}
                                    valueProp={"Id"}
                                    selectedOption={this.state}
                                    selectedOptionProp={"qbo_InvoiceClassRef"}
                                />
                            </div>
                        </div>
                    </div>
                );

                return edit;
            }
        } else {
            return null;
        }
    };

    renderTaxJarExemption = (detail: IOrderDetailConfig, value: any, index: number) => {
        if (!this.props.supplierModel.Supplier_Integration.has_taxjar) {
            return null;
        }

        const label = <OwLabel isBold={true} title={"taxjar_exemption"} noBottomMargin={true} className={"me-1"} postText={":"} />;

        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span>{this.state.order.taxjar_exemption_type ? _.startCase(this.state.order.taxjar_exemption_type) : ""}</span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const exemptionOptions = [
                { value: TaxJarExemptionTypeEnum.NON_EXEMPT, title: "Non Exempt" },
                { value: TaxJarExemptionTypeEnum.WHOLESALE, title: "Wholesale" },
                { value: TaxJarExemptionTypeEnum.MARKETPLACE, title: "Marketplace" },
                { value: TaxJarExemptionTypeEnum.OTHER, title: "Other" },
                { value: TaxJarExemptionTypeEnum.GOVERNMENT, title: "Government" },
            ];

            const edit = (
                <div className={"d-flex w-100"}>
                    <span className={this.state.labelWidth}>{label}</span>
                    <div className={"position-relative"}>
                        <OwSelectOption
                            name={"taxjar_exemption_type"}
                            fn={(e: any) => {
                                this.rowUpdate(e, detail, index, "taxjar_exemption_type");
                            }}
                            options={exemptionOptions}
                            selectedOption={this.props.order}
                            selectedOptionProp={"taxjar_exemption_type"}
                            valueProp={"value"}
                            titleProp={"title"}
                        />
                    </div>
                </div>
            );

            return edit;
        }
    };

    renderRepGroup = (detail: IOrderDetailConfig, value: any, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.Rep_Group && !this.state.order.Vendor?.Rep_Groups?.length) {
                return null;
            }
        }

        const label = <OwLabel isBold={true} title={"rep_group"} noBottomMargin={true} className={"me-1"} postText={":"} />;

        const selectedRepGroup = this.state.order.Rep_Group || this.state.order.Vendor?.Rep_Groups?.[0];

        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span>{selectedRepGroup?.name}</span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 flex-column"}>
                    <div>
                        <span className={this.state.labelWidth}>{label}</span>
                        <span>
                            {this.props.order.Rep_Group?.name}
                            {this.props.order.Rep_Group ? (
                                this.state.clearRepGroup ? (
                                    <OwButton
                                        className={"ms-1 btn-danger"}
                                        title={"cancel"}
                                        fn={() => {
                                            this.clearRepGroup(false);
                                        }}
                                    />
                                ) : (
                                    <OwButton
                                        className={"ms-1 btn-primary"}
                                        title={"clear"}
                                        fn={() => {
                                            this.clearRepGroup(true);
                                        }}
                                    />
                                )
                            ) : null}
                        </span>
                        <div className={"position-relative mt-1"}>
                            <Typeahead
                                isSelectableFn={() => {
                                    return true;
                                }}
                                typeaheadApiFn={this.lookupRepGroup}
                                selectedItemFn={this.assignRepGroup}
                                selectedItem={this.state.selectedRepGroup}
                                typeaheadItems={this.state.foundRepGroups}
                                selectedItemTitleProp={"name"}
                                titleProp={"name"}
                                subTitleProp={"email"}
                                clearTypeahead={this.state.clearRepGroupTypeahead}
                                clearTypeaheadCallback={this.clearSelectedRepGroup}
                            />
                        </div>
                    </div>
                </div>
            );

            return edit;
        }
    };

    renderWorkflow = (detail: IOrderDetailConfig, value: any, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!this.state.order.Workflow) {
                return null;
            }
        }

        const label = <OwLabel isBold={true} title={"workflow"} noBottomMargin={true} className={"me-1"} postText={":"} />;

        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span>{this.state.order.Workflow?.name}</span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 flex-column"}>
                    <div>
                        <span className={this.state.labelWidth}>{label}</span>
                        <span>{this.props.order.Workflow?.name}</span>
                        <div className={"position-relative"}>
                            <OwSelectOption
                                name={"workflow_id"}
                                options={this.state.workflows}
                                fn={this.handleChange}
                                selectedOption={this.props.order}
                                selectedOptionProp={"workflow_id"}
                                valueProp={"id"}
                                titleProp={"name"}
                            />
                        </div>
                    </div>
                </div>
            );

            return edit;
        }
    };

    renderUser = (detail: IOrderDetailConfig, value: any, index: number) => {
        const label = <OwLabel isBold={true} title={"user"} noBottomMargin={true} className={"me-1"} postText={":"} />;

        const display = (
            <div className={"d-flex w-100"}>
                <span className={this.state.labelWidth}>{label}</span>
                <span>{this.state.order.User?.name}</span>
            </div>
        );

        if (this.props.isReadOnly || !this.state.detailsEditMode) {
            return display;
        } else {
            const edit = (
                <div className={"d-flex w-100 flex-column"}>
                    <div>
                        <span className={this.state.labelWidth}>{label}</span>
                        <span>{this.props.order.User?.name}</span>
                        <div className={"position-relative"}>
                            <Typeahead
                                isSelectableFn={() => {
                                    return true;
                                }}
                                typeaheadApiFn={this.lookupUser}
                                selectedItemFn={this.assignUser}
                                selectedItem={this.state.selectedUser}
                                typeaheadItems={this.state.foundUsers}
                                selectedItemTitleProp={"name"}
                                titleProp={"name"}
                                subTitleProp={"email"}
                                clearTypeahead={this.state.clearUserTypeahead}
                                clearTypeaheadCallback={this.clearSelectedUser}
                            />
                        </div>
                    </div>
                </div>
            );

            return edit;
        }
    };

    renderTextAreaEdit = (detail: IOrderDetailConfig, value: any, index: number) => {
        if (!this.state.viewAllDetails) {
            if (!value) {
                return null;
            }
        }

        return (
            <div className={this.props.isEcommerceView ? "d-flex" : `d-flex w-100 ${this.state.mdColumns} col-12`}>
                <OwLabel
                    title={detail.title}
                    postText={":"}
                    className={"me-2"}
                    isBold={true}
                    supplierModel={this.props.supplierModel}
                    isSupplierVendorOverride={!!detail.isSupplierVendorOverride}
                />
                <span className={this.state.componentWidth}>
                    <OwTextArea
                        name={detail.valueProp}
                        fn={(e: any) => {
                            this.rowUpdate(e, detail, index, detail.valueProp);
                        }}
                        value={value}
                    />
                </span>
            </div>
        );
    };

    _createDetailsViewFromConfig = (detail: IOrderDetailConfig, index: number) => {
        let isVisible = true;

        if (detail.isVisibleFn) {
            isVisible = this.processIsVisibleFn(detail);
        }

        if (!isVisible) {
            return null;
        }

        if (detail.isSupplierUserOnly) {
            if (!this.props.userModel.isSupplierUser) {
                return null;
            }
        }

        if (detail.renderFn) {
            return this.processRenderFn(detail, index);
        }

        let baseObject = this.props.order;

        if (detail.baseObject) {
            // @ts-expect-error Has an any type
            baseObject = this.props.order[detail.baseObject];
        }

        if (!_.isNil(baseObject)) {
            // @ts-expect-error Has an any type
            let value = baseObject[detail.valueProp] || "";

            if (!_.isNil(value)) {
                if (detail.valueSubProp) {
                    value = _.get(baseObject, `[${detail.valueProp}][${detail.valueSubProp}]`, "");
                }

                if (detail.isDate) {
                    value = UserService.parseDate(value);
                }

                if (!this.props.isReadOnly && this.state.detailsEditMode && detail.isEditable) {
                    switch (detail.valueProp) {
                        case "Vendor_Source_Location":
                            return this.renderVendorSourceLocationEdit(detail, value, index);
                            break;

                        default:
                            return this.renderTextAreaEdit(detail, value, index);
                            break;
                    }
                } else {
                    if (detail.title) {
                        return (
                            <div key={index} className={this.props.isEcommerceView ? "" : `col-12 ${this.state.mdColumns} mb-1`}>
                                <OwLabel
                                    title={detail.title}
                                    postText={":"}
                                    className={this.state.labelWidth}
                                    isBold={true}
                                    supplierModel={this.props.supplierModel}
                                    isSupplierVendorOverride={!!detail.isSupplierVendorOverride}
                                />
                                {value}
                            </div>
                        );
                    } else {
                        // this facilitates a blank space
                        return <div key={index} className={this.props.isEcommerceView ? "" : `col-12 ${this.state.mdColumns} mb-1`}></div>;
                    }
                }
            } else {
                return null;
            }
        } else {
            return null;
        }
    };

    _createShippingView = (detail: IStandardRoomDetailItem, index: number) => {
        const renderedView = detail.renderFn(detail, index);

        if (renderedView) {
            return (
                <div key={index} className={"col-12 mb-1"}>
                    {renderedView}
                </div>
            );
        } else {
            return null;
        }
    };

    getLineItemView = (readOnly: boolean, processedDetailsView: any, shippingView: any, customShippingDetailView: any) => {
        return (
            <div>
                <div className={"ms-3 h-3r "}>
                    <div className={readOnly ? "d-none" : ""}>
                        {readOnly ? null : (
                            <>
                                <OwButton
                                    className={
                                        this.state.detailsEditMode
                                            ? "d-none"
                                            : "d-inline-flex align-items-center pointer bottom-border-on-hover-warning d-print-none btn btn-warning btn-sm"
                                    }
                                    title={"edit"}
                                    leftIconClass={"fas fa-pencil"}
                                    fn={this.toggleDetailsEditMode}
                                />
                                {/* TODO */}
                                {this.state.detailsEditMode ? null : (
                                    <OwButton
                                        className={"w-auto ms-2 me-2 btn-primary"}
                                        title={this.state.viewAllDetails ? "view_less" : "view_all"}
                                        fn={this.toggleViewAllDetails}
                                    />
                                )}
                            </>
                        )}
                        <span className={this.state.detailsEditMode ? "d-inline-flex align-items-center" : "d-none"}>
                            <ButtonGroup>
                                <OwButton
                                    className={"bg-success text-white"}
                                    title={"save"}
                                    leftIconClass={"fas fa-check"}
                                    fn={this.updateOrderEntryDetail}
                                />

                                <OwButton
                                    className={"bg-danger text-white"}
                                    title={"cancel"}
                                    leftIconClass={"fas fa-times"}
                                    fn={() => {
                                        this.toggleDetailsEditMode(undefined, true);
                                    }}
                                />
                            </ButtonGroup>
                            {this.state.detailsEditMode ? (
                                <OwButton
                                    className={"w-auto ms-2 me-2 btn-primary"}
                                    title={this.state.viewAllDetails ? "view_less" : "view_all"}
                                    fn={this.toggleViewAllDetails}
                                />
                            ) : null}
                        </span>
                    </div>
                </div>
                <div id={"orderDetails"} className={this.state.editMode ? "d-none" : "d-flex flex-column"}>
                    {processedDetailsView}
                </div>
                {this.props.order.is_local_pickup ? null : <hr className={"border-white ms-2 me-2"} />}
                {this.props.supplierModel ? (
                    <div id={"shippingDetails"} className={"d-flex"}>
                        {customShippingDetailView.length ? <div className={"w-70"}>{customShippingDetailView}</div> : null}
                        <div className={customShippingDetailView.length ? "w-30" : ""}>
                            <div className={"pb-3 p-3 " + (this.state.editMode ? "d-none" : "d-flex flex-column")}>{shippingView}</div>
                        </div>
                    </div>
                ) : null}
            </div>
        );
    };

    getEcommerceView = (readOnly: boolean, processedDetailsView: any, shippingView: any) => {
        return (
            <div className={"ecommerce-view"}>
                <div className={"col-12 mb-3 "}>
                    <div className={readOnly ? "d-none" : ""}>
                        {readOnly ? null : (
                            <span
                                id={"editDetails"}
                                className={
                                    this.state.detailsEditMode
                                        ? "d-none"
                                        : "d-inline-flex align-items-center faded-orange pointer bottom-border-on-hover-warning"
                                }
                                onClick={this.toggleDetailsEditMode}>
                                <i className={"far fa-pencil "} />
                                <span className={"ps-2"}>
                                    <OwTranslate defaultMessage={"edit"} id={"edit"} />
                                </span>
                            </span>
                        )}
                        <span className={this.state.detailsEditMode ? "d-inline-flex align-items-center" : "d-none"}>
                            <span
                                className={"text-success pointer d-inline-flex align-items-center bottom-border-on-hover-success"}
                                onClick={this.updateOrderEntryDetail}>
                                <i className={"far fa-check me-2"} />
                                <OwTranslate defaultMessage={"save"} id={"save"} />
                            </span>
                            <span
                                className={"text-danger ms-4 pointer d-inline-flex align-items-center bottom-border-on-hover-danger"}
                                onClick={(e: any) => {
                                    this.toggleDetailsEditMode(e, true);
                                }}>
                                <i className={"far fa-times me-2"} />
                                <OwTranslate defaultMessage={"cancel"} id={"cancel"} />
                            </span>
                        </span>
                    </div>
                </div>
                <div className={"details-section flex-column flex-md-row"}>
                    <div id={"orderDetails"} className={this.state.editMode ? "d-none" : "d-flex flex-column"}>
                        {processedDetailsView}
                    </div>
                    {this.props.supplierModel ? <div className={"v-bar"}></div> : null}
                    {this.props.supplierModel ? (
                        <div id={"shippingDetails"} className={"d-flex"}>
                            <div>
                                <div className={"pb-3 " + (this.state.editMode ? "d-none" : "d-flex flex-column")}>{shippingView}</div>
                            </div>
                        </div>
                    ) : null}
                </div>
            </div>
        );
    };

    getRelatedOrdersPanel = () => {
        return <RelatedOrdersPanel relatedOrders={this.props.relatedOrders || []} />;
    };

    /**
     * This function sets up the Details Panel for the User
     */
    getDetailsPanel = () => {
        const detailItems = this.getDetailItems();

        const mainView = detailItems.mainView;

        let detailsView: any = null;

        if (!this.props.supplierModel.order_details_config) {
            detailsView = mainView.map((detail: IStandardRoomDetailItem, index: number) => {
                return this._createDetailsView(detail, index);
            });
        } else {
            detailsView = this.props.supplierModel.order_details_config.map((detail: IOrderDetailConfig, index: number) => {
                return this._createDetailsViewFromConfig(detail, index);
            });
        }

        const shippingView = this.props.supplierModel
            ? detailItems.shippingView.map((detail, index) => {
                  return this._createShippingView(detail, index);
              })
            : [];

        const customShippingDetailView = this.props.supplierModel
            ? detailItems.customShippingDetail.map((detail, index) => {
                  return this._createShippingView(detail, index);
              })
            : [];

        const size = this.props.supplierModel.guid === SupplierGuidEnum.PANASONIC_CA ? 4 : 3;

        const nonNullDetailsView = detailsView
            .filter((detail: any) => detail !== null)
            .filter((detail: any) => (typeof detail === "string" ? detail.length > 0 : true));

        const processedDetailsView = _.chunk(nonNullDetailsView, size).map((group: any, index: number) => {
            return (
                <div key={index} className="row ms-0 me-0 mb-2">
                    {group}
                </div>
            );
        });

        const readOnly = this.props.isReadOnly; // isReadOnly();

        if (this.props.isEcommerceView) {
            return this.getEcommerceView(readOnly, detailsView, shippingView);
        } else {
            return this.getLineItemView(readOnly, processedDetailsView, shippingView, customShippingDetailView);
        }
    };

    getRmasPanel = () => {
        return <OrderEntryRmasPanel order={this.props.order} />;
    };

    getShipmentsPanel = () => {
        return <OrderEntryShipmentsPanel order={this.props.order} isReadOnly={this.props.isReadOnly} />;
    };

    getFastboundPanel = () => {
        return <OrderEntryFastboundPanel order={this.props.order} />;
    };

    getUnanetSyncStatusPanel = () => {
        return <UnanetOrderSyncStatus order={this.props.order} />;
    };

    detailPanel = () => {
        // if(_.isNil(this.state.order.client)){
        //     this.state.order.client = {name: ''};
        // }

        // if(_.isNil(this.state.order.details)){
        //     this.state.order.details = {};
        // }
        if (!this.props.supplierModel || !this.props.userModel) {
            return null;
        }

        const isReadOnly = this.props.isReadOnly; // .isReadOnly();

        if (this.props.isEcommerceView) {
            return this.getDetailsPanel();
        } else {
            const tabOptions = [
                {
                    name: "Details",
                    panelComponent: this.getDetailsPanel(),
                    icon: "fad fa-info-circle",
                },
            ];

            if (this.props.relatedOrders?.length) {
                tabOptions.push({
                    name: "Related Orders",
                    panelComponent: this.getRelatedOrdersPanel(),
                    icon: "fad fa-exchange-alt",
                });
            }

            if (this.props.supplierModel.has_rma && this.props.order.RMAs?.length) {
                tabOptions.push({
                    name: "RMA",
                    panelComponent: this.getRmasPanel(),
                    icon: "fad fa-rotate-left",
                });
            }

            if (this.props.supplierModel.has_shipments && !this.props.order.is_quote && !this.props.order.is_template) {
                tabOptions.push({
                    name: "Shipments",
                    panelComponent: this.getShipmentsPanel(),
                    icon: "fad fa-box",
                });
            }

            if (!this.state.isOfflineOrder && !this.props.supplierModel.settings?.screens?.order_entry?.hide_files) {
                tabOptions.push({
                    name: "Files",
                    icon: "fad fa-file-alt",
                    panelComponent: (
                        <div className={"p-2"}>
                            <OrderEntryFileManager
                                supplierModel={this.props.supplierModel}
                                socket={this.props.socket}
                                userModel={this.props.userModel}
                                orderGuid={this.props.order.guid}
                                vendorModel={this.state.vendorModel}
                                orderModel={this.state.order}
                                isReadOnly={isReadOnly}
                            />
                        </div>
                    ),
                });

                if (this.props.supplierModel.has_purchase_orders) {
                    if (this.props.order.Purchase_Orders?.length) {
                        tabOptions.push({
                            name: "POs",
                            icon: "fad fa-th-list",
                            panelComponent: <OrderEntryPurchaseOrderPanel order={this.props.order} />,
                        });
                    }
                }

                if (
                    (this.props.supplierModel.has_csv_order_entry || this.props.supplierModel.has_custom_imports) &&
                    !(this.props.userModel.supplierUserToken?.access_type_id === AccessTypesEnum.READ_ONLY)
                ) {
                    if (
                        this.props.order.order_source_id === OrderSourceEnum.ORDERWERKS ||
                        this.props.order.order_source_id === OrderSourceEnum.APP
                    ) {
                        tabOptions.push({
                            name: "Import",
                            icon: "fad fa-file-import",
                            panelComponent: (
                                <div className={"p-2"}>
                                    <OrderEntryCsvImport
                                        orderGuid={this.props.order.guid}
                                        orderModel={this.state.order}
                                        isReadOnly={isReadOnly}
                                        addBulkItems={this.props.addBulkItems}
                                        getOrder={this.props.getOrder}
                                    />
                                </div>
                            ),
                        });
                    }
                }

                if (this.props.supplierModel.Supplier_Integration?.has_fastbound && this.props.userModel.isSupplierUser) {
                    tabOptions.push({
                        name: "FastBound",
                        panelComponent: this.getFastboundPanel(),
                        icon: "fad fa-book",
                    });
                }
            }

            if (this.props.supplierModel.Supplier_Integration.has_unanet) {
                tabOptions.push({
                    name: "Unanet",
                    icon: "fad fa-sync-alt",
                    panelComponent: this.getUnanetSyncStatusPanel(),
                });
            }

            const tabs = tabOptions.map((opt, index) => {
                const tabName = <FormattedMessage id={_.lowerCase(opt.name)} defaultMessage={opt.name} description="Tab Item Title" />;

                const nameSetup = (
                    <>
                        {opt.icon ? <i className={`${opt.icon} me-2`} /> : null}
                        {tabName}
                    </>
                );

                if (opt.name === "Catalog") {
                    if (this.state.order!.catalog_id) {
                        return <Tab key={index}>{nameSetup}</Tab>;
                    }
                } else if (opt.name === "Files") {
                    if (this.state.order) {
                        return (
                            <Tab key={index}>
                                {nameSetup}
                                <span
                                    style={{ fontSize: "14px" }}
                                    className={
                                        "file-attachments " +
                                        (this.state.order?.attachments?.length ? "ms-2 faded-orange-bg attachment-circle" : "d-none")
                                    }>
                                    {this.state.order?.attachments?.length}
                                </span>
                            </Tab>
                        );
                    }
                } else if (opt.name === "POs") {
                    if (this.state.order) {
                        return (
                            <Tab key={index}>
                                {nameSetup}
                                <span
                                    style={{ fontSize: "14px" }}
                                    className={
                                        "file-attachments " +
                                        (this.state.order?.Purchase_Orders?.length ? "ms-2 faded-orange-bg attachment-circle" : "d-none")
                                    }>
                                    {this.state.order?.Purchase_Orders?.length}
                                </span>
                            </Tab>
                        );
                    }
                } else {
                    return <Tab key={index}>{nameSetup}</Tab>;
                }
            });

            const tabPanels = tabOptions.map((opt, index) => {
                if (opt.name === "Catalog") {
                    if (this.state.order!.catalog_id) {
                        return <TabPanel key={index}>{opt.panelComponent}</TabPanel>;
                    }
                } else {
                    return <TabPanel key={index}>{opt.panelComponent}</TabPanel>;
                }
            });

            return (
                <Tabs forceRenderTabPanel={true}>
                    <TabList>{tabs}</TabList>

                    {tabPanels}
                </Tabs>
            );
        }
    };

    afterOpenModal = () => {};

    closeModal = () => {
        this.setState({
            modalIsOpen: false,
            modalHeight: "15rem",
        });
    };

    render() {
        const detailPanel = this.detailPanel();

        return !_.isNil(this.state.order) ? (
            <div className={"OrderEntryDetailsPanel"}>
                {detailPanel}

                <ReactModal
                    isOpen={this.state.modalIsOpen}
                    onAfterOpen={this.afterOpenModal}
                    onRequestClose={this.closeModal}
                    contentLabel="Modal"
                    style={{ content: { height: this.state.modalHeight } }}
                    className={"modalClass"}
                    overlayClassName={"overlayClass"}
                    ariaHideApp={true}>
                    {this.state.modalComponent}
                </ReactModal>
            </div>
        ) : null;
    }
}

export default OrderEntryDetailsPanel;
